/*!
 * Bazaarvoice bv-loader v13.24.3
 * Mon Apr 15 2024 18:45:16 GMT+0000 (Coordinated Universal Time)
 *
 * Capabilities:
 *
 *   api@0.8.2
 *   inline_ratings@2.4.7
 *   inpage_submission@4.12.3
 *   rating_summary@2.64.1
 *   ratings@0.1.23
 *   swat-submission@4.8.3
 *   swat_container@1.3.5
 *   swat_reviews@6.24.23
 *
 * http://bazaarvoice.com
 *
 * Copyright 2024 Bazaarvoice. All rights reserved.
 *
 */
(() => {
  var e = {
      353: (e, t, n) => {
        "use strict";
        n.d(t, {
          M: () => c,
        });
        var r,
          o = n(788),
          a = n.n(o),
          i = n(318),
          s = n(920),
          c = function () {
            var e = {
              timeout: 6e4,
            };
            return (
              r ||
              (r = new s(function (t, n) {
                var r = (i.Z.global && i.Z.global.serverEnvironment) || "prod";
                a().loadScript(
                  "https://".concat(
                    "prod" === r ? "apps" : "apps-qa",
                    ".bazaarvoice.com/analytics/bv-analytics.js"
                  ),
                  e,
                  function (e) {
                    e ? n(e) : t();
                  }
                );
              }))
            );
          };
      },
      426: (e, t, n) => {
        var r = n(422),
          o =
            r.document &&
            (r.document.currentScript ||
              r.document.querySelector('script[src*="bv.js"]'));
        e.exports = o;
      },
      197: (e, t, n) => {
        "use strict";
        n.d(t, {
          Z: () => Rn,
        });
        var r,
          o,
          a = n(690),
          i = n(304),
          s = n(318),
          c = n(886),
          u = n(422),
          l = (n(581).shadowQuerySelectorAll, "ADDED"),
          f = "REMOVED",
          d = ["data-bv-show", "name"],
          m = [],
          p = "",
          v = new WeakMap(),
          h = function (e, t) {
            return e.matches ? e.matches(t) : e.msMatchesSelector(t);
          },
          b = function (e) {
            var t = v.get(e);
            t &&
              (t.watches.forEach(function (t) {
                (0, t.callback)(f, e);
              }),
              t.observer.disconnect(),
              v.delete(e));
          },
          g = function (e) {
            return new u.MutationObserver(function (t) {
              t.forEach(function (t) {
                h(e, p)
                  ? (function (e, t) {
                      v.get(e).watches.forEach(function (n) {
                        (0, n.callback)("UPDATED", e, t);
                      });
                    })(e, t)
                  : b(e);
              });
            });
          },
          y = function (e, t) {
            var n,
              r = m.filter(function (t) {
                var n = t.selector;
                return h(e, n);
              }),
              o = r.reduce(function (e, t) {
                var n = t.attributes,
                  r = void 0 === n ? [] : n;
                return e.concat(r);
              }, []),
              a = r;
            v.has(e) ? ((n = v.get(e).observer), t && (a = [t])) : (n = g(e)),
              n.observe(e, {
                attributes: !0,
                attributeFilter: o.length ? o : void 0,
              }),
              v.set(e, {
                watches: r,
                observer: n,
              }),
              a.forEach(function (t) {
                (0, t.callback)(l, e);
              });
          },
          w = function (e) {
            for (var t = e.length, n = 0; n < t; n++) {
              for (
                var r = e[n], o = r.addedNodes, a = o.length, i = 0;
                i < a;
                i++
              ) {
                var s = o[i];
                if ((s.matches || s.msMatchesSelector) && h(s, p)) y(s);
                else if (s.querySelectorAll) {
                  var c = s.querySelectorAll(p);
                  if (c.length > 0) for (var u = 0; u < c.length; u++) y(c[u]);
                }
              }
              for (var l = r.removedNodes, f = l.length, d = 0; d < f; d++) {
                var m = l[d];
                if ((m.matches || m.msMatchesSelector) && h(m, p)) b(m);
                else if (m.querySelectorAll) {
                  var v = m.querySelectorAll(p);
                  if (v.length > 0) for (var g = 0; g < v.length; g++) b(v[g]);
                }
              }
              if ("attributes" === r.type) {
                var w = r.target;
                (w.matches || w.msMatchesSelector) && h(w, p) && y(w);
              }
            }
          },
          E = function (e) {
            var t = e.selector;
            m.push(e),
              (p += "" === p ? t : ",".concat(t)),
              (function (e) {
                var t = u.document.querySelectorAll(e.selector);
                Array.prototype.forEach.call(t, function (t) {
                  y(t, e);
                });
              })(e);
          };
        (r = document),
          (o = {
            subtree: !0,
            childList: !0,
            attributes: !0,
            attributeFilter: d,
          }),
          new u.MutationObserver(w).observe(r, o);
        var S = n(5),
          _ = n.n(S),
          k = {},
          O = {
            get: function (e) {
              return k[e];
            },
          };
        _().call(O);
        E({
          selector: 'meta[name^="'.concat("bv:", '"]'),
          attributes: ["name", "content"],
          callback: function (e, t) {
            var n = t.name.replace(new RegExp("^".concat("bv:")), "");
            e === f
              ? (delete k[n], delete O[n])
              : (k[n] = t.getAttribute("content")),
              O.trigger("change", n);
          },
        });
        var T = function () {
            return O;
          },
          C = function () {
            return k.pageType || void 0;
          },
          N = n(920);
        (s.Z.global = {}),
          (0, c.Z)(s.Z.global, {
            client: a.Z.deployment.client,
            dataEnvironment: a.Z.dataEnvironment,
            serverEnvironment: a.Z.serverEnvironment,
            locale: a.Z.deployment.locale,
            anonymous: !0,
            siteId: a.Z.deployment.site,
            virtualEnvironment: a.Z.deployment.virtualEnvironment,
            ponyfills: {
              Promise: N,
            },
            SystemJS: {},
            meta: T(),
          }),
          (0, c.Z)(s.Z.global, {
            loadUserSegment: (0, i.vd)(),
          }),
          Object.freeze(s.Z.global);
        const A = s.Z.global;
        var P = n(388),
          x = n.n(P),
          I = n(426),
          R = n.n(I),
          V = /[,\s]\s*/,
          B = "bvCallback",
          j = (function () {
            if (!R()) return [];
            var e = R().getAttribute("data-bv-preload");
            return e ? e.split(V) : [];
          })(),
          L = (R() && R().getAttribute("data-bv-callback")) || B,
          Z = R() && R().getAttribute("data-bv-display-code"),
          D = R() && R().getAttribute("data-bv-hostname"),
          M = n(611),
          q = n.n(M);

        function U() {
          return (
            (U = Object.assign
              ? Object.assign.bind()
              : function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n)
                      Object.prototype.hasOwnProperty.call(n, r) &&
                        (e[r] = n[r]);
                  }
                  return e;
                }),
            U.apply(this, arguments)
          );
        }
        var F = n(422),
          W = q()(a.Z.domains, F.location.hostname);
        const z = function (e) {
          var t = e.commonData,
            n = e.name,
            r = e.source,
            o = U({}, t);
          (o.locale = a.Z.deployment.locale),
            (o.deploymentZone = a.Z.deployment.site);
          var i = {
              name: n,
              client: a.Z.deployment.client,
              display: Z || a.Z.displayCode,
              environment: a.Z.vpc,
              source: r,
              staging: "stg" === a.Z.dataEnvironment || "qa" === a.Z.vpc,
              anonymous: A.anonymous,
              brandDomain: W.get("firstPartyCookieEnabled")
                ? W.get("domain")
                : "",
              commonData: o,
            },
            s = new (x())(i);
          return (
            "europe" === a.Z.piiDataRegion && s.setEU(!0),
            a.Z.webAnalyticsIntegrationConfigs &&
              a.Z.webAnalyticsIntegrationConfigs.length &&
              a.Z.webAnalyticsIntegrationConfigs.forEach(function (e) {
                s.configureSCIProvider(e.name, e);
              }),
            s
          );
        };
        const H = z({
          commonData: {
            bvProduct: "bv-loader",
            bvProductVersion: a.Z.scoutVersion,
          },
          name: "bv-loader",
          source: "bv-loader",
        });
        var $ = n(64);
        if ("undefined" != typeof window) {
          var Q = new RegExp(a.Z.paths.root);
          window.addEventListener("error", function (e) {
            var t = e.error,
              n = e.filename;
            Q.test(n) &&
              (H.trackError({
                message: t.message || t,
                stack: t.stack,
                type: "BV Loader Uncaught ".concat(t.name || "Error"),
              }),
              (0, $.Z)().then(function (e) {
                e(t);
              }));
          });
        }
        var J = n(916),
          K = void 0,
          G = 0,
          X = function (e) {
            J.mark(e);
          },
          Y = function () {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
              t[n] = arguments[n];
            return t.join("_");
          },
          ee = Y("BV", "PERF", "MARK"),
          te = function e(t) {
            for (
              var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1;
              o < n;
              o++
            )
              r[o - 1] = arguments[o];
            if (r.length) {
              var a = Y(t, r.shift());
              return e.call.apply(e, [K, a].concat(r));
            }
            var i = [],
              s = [],
              c = function (e) {
                X(e ? Y(t, e) : t);
                var n = J.getEntriesByType("mark"),
                  r = n[n.length - 1];
                return i.push(r), r;
              },
              u = {
                createMark: {
                  configurable: !0,
                  enumerable: !0,
                  value: e.bind(K, t),
                },
                marks: {
                  configurable: !0,
                  enumerable: !0,
                  get: function () {
                    return i;
                  },
                },
                measures: {
                  configurable: !0,
                  enumerable: !0,
                  get: function () {
                    return s;
                  },
                },
                start: {
                  configurable: !0,
                  enumerable: !0,
                  value: function () {
                    return (
                      (e = c("start")),
                      function () {
                        var n = c("end");
                        J.measure(t);
                        var r = J.getEntriesByType("measure"),
                          o = r[r.length - 1];
                        return (
                          Object.defineProperties(o, {
                            startTime: {
                              configurable: !0,
                              enumerable: !0,
                              value: e.startTime,
                              writable: !1,
                            },
                            duration: {
                              configurable: !0,
                              enumerable: !0,
                              value: n.startTime - e.startTime,
                              writable: !1,
                            },
                          }),
                          i.push(n),
                          s.push(o),
                          n
                        );
                      }
                    );
                    var e;
                  },
                },
              };
            return Object.defineProperties(c, u), c;
          };
        const ne = function (e) {
          for (
            var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1;
            r < t;
            r++
          )
            n[r - 1] = arguments[r];
          return te.call.apply(te, [K, Y(ee, e || ++G)].concat(n));
        };
        var re = n(334);

        function oe() {
          return (
            (oe = Object.assign
              ? Object.assign.bind()
              : function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n)
                      Object.prototype.hasOwnProperty.call(n, r) &&
                        (e[r] = n[r]);
                  }
                  return e;
                }),
            oe.apply(this, arguments)
          );
        }
        var ae = n(422),
          ie = function (e) {
            return e.map(function (e) {
              return oe({}, e, {
                value: String(e.value),
              });
            });
          },
          se = function (e) {
            return Object.keys(e)
              .map(function (t) {
                return {
                  name: t,
                  value: e[t],
                };
              })
              .filter(function (e) {
                return void 0 !== e.value;
              });
          },
          ce = function (e) {
            return e && e !== Math.floor(e) ? Number(e.toFixed(2)) : e;
          },
          ue = function (e, t) {
            var n = {},
              r = t ? s.Z._render.layouts[e].perfMark : s.Z[e].perfMark,
              o = J.getEntriesByType("resource")
                .filter(function (t) {
                  return (
                    !!t.name.match(re.Z.appNameRegex(e)) ||
                    !!t.name.match(re.Z.layoutNameRegex(e))
                  );
                })
                .shift();
            if (
              (r.bvShow.marks.length &&
                (n.bvShowProcessed = ce(r.bvShow.marks[0].startTime)),
              r.load.measures.length &&
                ((n.loadTime = ce(r.load.measures[0].duration)),
                (n.loadStart = ce(r.load.measures[0].startTime))),
              !t &&
                r.configure.measures.length &&
                (n.configurationTime = ce(
                  r.configuration.measures[0].duration
                )),
              r.render.measures.length &&
                ((n.avgRender = ce(
                  r.render.measures.reduce(function (e, t) {
                    return e + t.duration;
                  }, 0) / r.render.measures.length
                )),
                (n.render = r.render.measures.map(function (e) {
                  return ce(e.duration);
                })),
                (n.renderStart = r.render.measures.map(function (e) {
                  return ce(e.startTime);
                }))),
              o)
            ) {
              var a = o.fetchStart,
                i = o.transferSize,
                c = o.responseEnd,
                u = o.requestStart;
              (n.fetchStart = ce(a)),
                (n.responseEnd = ce(c)),
                u && ((n.transferSize = i), (n.ttfb = ce(a - u)));
            }
            return ie(se(n));
          },
          le = function (e) {
            return ue(e, !1);
          },
          fe = function () {
            var e = {},
              t = J.getEntriesByType("resource"),
              n = J.getEntriesByType("paint"),
              r = {
                totalPageRequests: 0,
                totalBVRequests: 0,
                totalCachedBVResources: 0,
                totalCachedOtherResources: 0,
                totalCumulativeLoadTime: 0,
                totalCumulativeBVLoadTime: 0,
                totalActualOtherLoadTime: 0,
                totalActualBVLoadTime: 0,
                totalNumOfBVScripts: 0,
                totalNumOfBVAPIRequests: 0,
                totalNumOfBVStylesheets: 0,
                totalNumOfBVImages: 0,
                totalNumOfOtherBVHTTPRequests: 0,
                totalNumOfOtherScripts: 0,
                totalNumOfOtherStylesheets: 0,
                totalNumOfOtherImages: 0,
                totalNumOfOtherHTTPRequests: 0,
                totalNumOfHTTP2Resources: 0,
                totalNumOfHTTP2BVResources: 0,
                pageStatus: document.readyState,
              },
              o = function (t, n) {
                var r = n.fetchStart,
                  o = n.responseEnd,
                  a = n.requestStart,
                  i = n.responseStart;
                e["".concat(t, "-fetchStart")] && (t = "".concat(t, "(2)")),
                  (e["".concat(t, "-fetchStart")] = ce(r)),
                  (e["".concat(t, "-responseEnd")] = ce(o)),
                  a && (e["".concat(t, "-ttfb")] = ce(i - a));
              };
            if (t.length) {
              var a = 0,
                i = 0,
                c = 0;
              t.forEach(function (t) {
                var n = t.name,
                  u = t.fetchStart,
                  l = t.duration,
                  f = t.responseEnd,
                  d = t.transferSize,
                  m = t.initiatorType,
                  p = t.nextHopProtocol,
                  v =
                    n.toLowerCase().includes("bv") ||
                    n.toLowerCase().includes("bazaarvoice");
                n.toLowerCase().includes("sid.gif") ||
                  n.toLowerCase().includes("st.gif") ||
                  n.toLowerCase().includes("a.gif") ||
                  (r.totalPageRequests++,
                  d && (e["".concat(n, "-transferSize")] = d),
                  f && c++,
                  n.toLowerCase().includes("components.js")
                    ? o("components.js", t)
                    : n.toLowerCase().includes("bv.js")
                    ? o("bv.js", t)
                    : n.match(re.Z.renderRegex) &&
                      (o("render.js", t),
                      (e.renderParseComplete = ce(
                        s.Z._render.perfMark.parseComplete.marks[0].startTime
                      ))),
                  (r.totalCumulativeLoadTime += ce(l)),
                  p.includes("2") &&
                    (r.totalNumOfHTTP2Resources++,
                    (n.includes("bv") || n.includes("bazaarvoice")) &&
                      r.totalNumOfHTTP2BVResources++),
                  v
                    ? (r.totalBVRequests++,
                      "css" === m
                        ? r.totalNumOfBVStylesheets++
                        : "script" === m
                        ? r.totalNumOfBVScripts++
                        : "img" === m
                        ? r.totalNumOfBVImages++
                        : "xmlhttprequest" === m || "" === m
                        ? r.totalNumOfBVAPIRequests++
                        : r.totalNumOfOtherBVHTTPRequests++)
                    : "css" === m
                    ? r.totalNumOfOtherStylesheets++
                    : "script" === m
                    ? r.totalNumOfOtherScripts++
                    : "img" === m
                    ? r.totalNumOfOtherImages++
                    : r.totalNumOfOtherHTTPRequests++,
                  v
                    ? ((r.totalCumulativeBVLoadTime += l),
                      l <= 10 && r.totalCachedBVResources++,
                      u > i
                        ? ((r.totalActualBVLoadTime += l), (i = f))
                        : f > i &&
                          u < i &&
                          ((r.totalActualBVLoadTime += f - i), (i = f)))
                    : (l <= 10 && r.totalCachedOtherResources++,
                      u > a
                        ? ((r.totalActualOtherLoadTime += l), (a = f))
                        : f > a &&
                          u < a &&
                          ((r.totalActualOtherLoadTime += f - a), (a = f))));
              }),
                oe(e, r, {
                  totalCumulativeLoadTime: ce(r.totalCumulativeLoadTime),
                  totalCumulativeBVLoadTime: ce(r.totalCumulativeBVLoadTime),
                  totalCumulativeOtherLoadTime: ce(
                    r.totalCumulativeLoadTime - r.totalCumulativeBVLoadTime
                  ),
                  totalActualBVLoadTime: ce(r.totalActualBVLoadTime),
                  totalActualOtherLoadTime: ce(r.totalActualOtherLoadTime),
                  totalNumOfHTTP1Resources:
                    t.length - r.totalNumOfHTTP2Resources,
                  totalNumOfHTTP1BVResources:
                    r.totalBVRequests - r.totalNumOfHTTP2BVResources,
                  percentResourcesLoaded: ce((c / r.totalPageRequests) * 100),
                });
            }
            return (
              n.length &&
                n.forEach(function (t) {
                  var n = t.name
                    .split("-")
                    .map(function (e, t) {
                      return t > 0
                        ? ""
                            .concat(e[0].toUpperCase())
                            .concat(e.slice(1, e.length))
                        : e;
                    })
                    .join("");
                  e[n] = ce(t.startTime);
                }),
              ie(se(e))
            );
          },
          de = n(974),
          me = n.n(de),
          pe = "bv_metrics",
          ve = s.Z.cookie || me(),
          he = function () {
            return ve.create(pe, !0, 72e5 / 864e5), !0;
          },
          be = !!ve.read(pe) || (!Math.floor(1e3 * Math.random()) && he());
        const ge = function (e, t, n, r) {
          if (be && t.length) {
            he();
            var o = {
              type: "performance",
              name: "Display",
              scope: e,
              metrics: t,
            };
            n && (o.bvProduct = n),
              r && (o.bvProductVersion = r),
              H.trackEvent("Diagnostic", o);
          }
        };
        var ye = n(423),
          we = n.n(ye),
          Ee = n(581),
          Se = {},
          _e = {},
          ke = "bvShow",
          Oe = we()(Array),
          Te = function (e, t) {
            e.filter(function (e) {
              return !e.dataset.bvReady;
            }).forEach(function (e) {
              var n = e.dataset[ke];
              Se[n] &&
                Se[n].forEach(function (r) {
                  if ("spotlights" === n && t) {
                    var o = e.parentElement;
                    e.removeAttribute("data-bv-ready"),
                      o.replaceChild(e.cloneNode(!1), e);
                  } else r(e), (e.dataset.bvReady = !0);
                });
            });
          },
          Ce = function (e) {
            e.filter(function (e) {
              return e.dataset.bvReady;
            }).forEach(function (e) {
              var t = e.dataset[ke];
              _e[t] &&
                _e[t].forEach(function (t) {
                  t(e), delete e.dataset.bvReady;
                });
            });
          },
          Ne = function (e, t) {
            Se[e] || (Se[e] = []),
              Se[e].push(t),
              (function (e) {
                return Oe.then(function (t) {
                  var n = document.querySelectorAll(
                    "[".concat("data-bv-show", "]")
                  );
                  return t.prototype.filter.call(n, function (t) {
                    return !e || t.dataset[ke] === e;
                  });
                });
              })(e).then(Te);
          },
          Ae = [
            "data-bv-product-id",
            "data-bv-productId",
            "data-bv-productid",
            "data-bv-show",
            "data-bv-subject-id",
          ],
          Pe = "bv-loader",
          xe = "Shown",
          Ie = "SwatDeeplinkRedirect",
          Re = "BV_HOSTED_V2",
          Ve = "CLIENT_HOSTED_V2",
          Be = "PRODUCT_DISPLAY_PAGE",
          je = a.Z.apps.reduce(function (e, t) {
            var n = t.publicName;
            return (e[t.name] = n), e;
          }, {}),
          Le = Object.keys(je).reduce(function (e, t) {
            return (e[je[t]] = function () {}), e;
          }, {}),
          Ze = function (e, t, r) {
            var o = e.config.name,
              a = je[o],
              i = (r.bvShow = r.createMark("bvShow"));
            a &&
              (Le[a] = function () {
                t()(),
                  e.ready(function () {
                    i.start(),
                      Ne(a, function (t) {
                        n.g.BV &&
                          n.g.BV.Spotlights &&
                          "spotlights" === a &&
                          delete n.g.BV.Spotlights,
                          e.trigger("container_added", t);
                      }),
                      (function (e, t) {
                        _e[e] || (_e[e] = []), _e[e].push(t);
                      })(a, function (t) {
                        e.trigger("container_removed", t);
                      });
                  }),
                  (Le[a] = function () {});
              });
          },
          De = function (e) {
            e.forEach(function (e) {
              var t = e.dataset[ke];
              Le[t] && Le[t]();
            });
          },
          Me = n(788),
          qe = n.n(Me),
          Ue = n(920);

        function Fe() {
          return (
            (Fe = Object.assign
              ? Object.assign.bind()
              : function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n)
                      Object.prototype.hasOwnProperty.call(n, r) &&
                        (e[r] = n[r]);
                  }
                  return e;
                }),
            Fe.apply(this, arguments)
          );
        }
        var We = n(422),
          ze = We.console,
          He = !1;

        function $e() {
          return (function () {
            var e = We.$BV || [],
              t = {
                _apiQueue: [],
                log: function () {
                  ze && ze.log && ze.log(arguments);
                },
                push: function (e) {
                  He ||
                    (function () {
                      if (
                        !a.Z.isConversations &&
                        (D &&
                          (a.Z.legacyScoutUrl = a.Z.legacyScoutUrl.replace(
                            /^(https?:\/\/)([^/]+)/,
                            "$1".concat(D)
                          )),
                        Z &&
                          (a.Z.legacyScoutUrl = a.Z.legacyScoutUrl.replace(
                            /\/+([^/]+)\/bvapi.js/,
                            "/".concat(Z, "/bvapi.js")
                          )),
                        /\[HOSTNAME\]/.test(a.Z.legacyScoutUrl) ||
                          /\[DISPLAYCODE\]/.test(a.Z.legacyScoutUrl))
                      )
                        throw Error(
                          'Could not determine display code and hostname. Contact Bazaarvoice Support to configure your implementation, or provide explicit "data-bv-display-code" and "data-bv-hostname" attributes.'
                        );
                      (He = !0), qe().loadScript(a.Z.legacyScoutUrl);
                    })(),
                    t._apiQueue.push(e);
                },
              },
              n = k.userToken || void 0;
            n &&
              t._apiQueue.push([
                "configure",
                "global",
                {
                  userToken: n,
                },
              ]),
              e.forEach(function (e) {
                t.push(e);
              });
            return (
              [
                "ui",
                "configure",
                "container",
                "ready",
                "SI.trackProductPageView",
                "SI.trackGenericPageView",
                "SI.trackTransactionPageView",
                "SI.disable",
                "SI.enable",
                "SI.setDebugEnabled",
                "SI.trackConversion",
                "DSI.trackBVPageView",
                "DSI.trackProduct",
                "DSI.trackTransaction",
              ].forEach(function (e) {
                !(function (e, n) {
                  for (var r, o = n.split("."), a = o.pop(), i = o.shift(); i; )
                    (e = e[i] = e[i] || {}), (i = o.shift());
                  e[a] =
                    ((r = n.replace(/\./g, "_")),
                    function () {
                      for (
                        var e, n = [r], o = 0, a = arguments.length;
                        o < a;
                        o++
                      )
                        n.push(arguments[o]);
                      return "ui" !== r
                        ? t.push(n)
                        : (((e = n[3] = n[3] || {}).loadedDeferred =
                            e.loadedDeferred || new Qe()),
                          t.push(n),
                          e.loadedDeferred.promise());
                    });
                })(t, e);
              }),
              t
            );
          })();
        }

        function Qe() {
          var e = this;
          this.promiseRef = new Ue(function (t, n) {
            Fe(e, {
              resolve: t,
              reject: n,
            });
          });
        }
        Qe.prototype.promise = function () {
          return this.promiseRef;
        };
        var Je = n(795),
          Ke = n.n(Je),
          Ge = n(422),
          Xe = Ge.BV && Ge.BV.cookieConsent ? Ge.BV.cookieConsent : Ke(),
          Ye = "cookies",
          et = T(),
          tt = {},
          nt = !a.Z.cookiesOptIn,
          rt = function () {
            var e =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : nt,
              t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : "default";
            e
              ? Xe.setConsent({
                  BVBRANDID: !0,
                  BVBRANDSID: !0,
                })
              : Xe.setConsent({
                  BVBRANDID: !1,
                  BVBRANDSID: !1,
                }),
              (tt[Ye] = {
                consent: e,
                source: t,
              });
          },
          ot = {},
          at = function (e) {
            if (e === Ye) {
              var t = et.get(Ye);
              void 0 === t ? rt() : rt("true" === t.toLowerCase(), "site");
            }
          };
        et.on("change", at);
        Object.defineProperty(ot, Ye, {
          get: function () {
            return tt[Ye];
          },
          set: function (e) {
            rt(e && !0 === e.consent, "manual");
          },
        });
        const it = ot;
        var st = "color:black; font-size:1.1em; font-weight:bold;",
          ct =
            "color: #0b6392; font-size:1.1em; text-decoration:none; font-weight:normal;",
          ut = "font-size:1.0em; font-weight:lighter;",
          lt = "www.betteryourhealth.com", //n.g.location.hostname,
          ft = q()(a.Z.domains, lt);

        function dt() {
          !(function (e) {
            if (!e.isValid)
              throw "Bazaarvoice is not configured for the domain ".concat(
                lt,
                "."
              );
          })(ft),
            (function (e) {
              if (e && e.src) {
                var t = re.Z.parseClient(e.src),
                  n = t && t.toLowerCase();
                if (t && t !== n) {
                  var r = e.src.replace(
                    "/deployments/".concat(t),
                    "/deployments/".concat(n)
                  );
                  console.warn(
                    "%cYou are using a cased client name (%c"
                      .concat(
                        t,
                        "%c) in the bv.js URL.\n        Please use this URL instead: %c"
                      )
                      .concat(
                        r,
                        "%c.\n        For details, see the Conversations Implementation section of https://knowledge.bazaarvoice.com."
                      ),
                    ct,
                    st,
                    ct,
                    ut,
                    ct
                  );
                }
              }
            })(R());
        }
        var mt = n(424),
          pt = n.n(mt),
          vt = n(920);

        function ht(e, t) {
          return (
            (function (e) {
              if (Array.isArray(e)) return e;
            })(e) ||
            (function (e, t) {
              var n =
                null == e
                  ? null
                  : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                    e["@@iterator"];
              if (null != n) {
                var r,
                  o,
                  a,
                  i,
                  s = [],
                  c = !0,
                  u = !1;
                try {
                  if (((a = (n = n.call(e)).next), 0 === t)) {
                    if (Object(n) !== n) return;
                    c = !1;
                  } else
                    for (
                      ;
                      !(c = (r = a.call(n)).done) &&
                      (s.push(r.value), s.length !== t);
                      c = !0
                    );
                } catch (e) {
                  (u = !0), (o = e);
                } finally {
                  try {
                    if (
                      !c &&
                      null != n.return &&
                      ((i = n.return()), Object(i) !== i)
                    )
                      return;
                  } finally {
                    if (u) throw o;
                  }
                }
                return s;
              }
            })(e, t) ||
            (function (e, t) {
              if (!e) return;
              if ("string" == typeof e) return bt(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return bt(e, t);
            })(e, t) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()
          );
        }

        function bt(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        var gt = document.createElement("script"),
          yt = window.navigator.userAgent.toLowerCase(),
          wt = {
            noModule: "noModule" in gt,
            isFirefox: !!~yt.indexOf("firefox"),
            isChrome: !!~yt.indexOf("chrome"),
          };
        (wt.isSafari = !wt.isChrome && !!~yt.indexOf("safari")),
          (wt.doModernLoad =
            wt.isSafari && wt.noModule
              ? (function () {
                  var e = yt.match(/macintosh.+mac os x (\d+)_(\d+)_\d+\)/),
                    t = yt.match(
                      /version\/(\d+)\.\d+\.\d+ safari\/\d+\.\d+\.\d/
                    );
                  if (e) {
                    var n = ht(e, 3),
                      r = n[1],
                      o = n[2];
                    if (Number(r) >= 10 && Number(o) >= 13 && t) {
                      var a = ht(t, 2)[1];
                      return Number(a) >= 11;
                    }
                    return !1;
                  }
                  return !0;
                })()
              : !wt.noModule && wt.isFirefox
              ? (function () {
                  var e = yt.match(/(?:firefox\/)([\d.]+)/);
                  if (e && e.length) {
                    var t = ht(e, 2)[1];
                    return Number(t) > 54;
                  }
                  return !1;
                })()
              : wt.noModule);
        const Et = wt;

        function St(e, t, n) {
          n.load.end = n.load.start();
          var r = e.sourcePath;
          e.legacyPath && !Et.doModernLoad && (r = e.legacyPath);
          if (
            (qe().loadScript(
              r,
              {
                timeout: 6e4,
              },
              function (r) {
                !(function (e, t, n, r) {
                  r.load.end(),
                    e &&
                      ((0, $.Z)().then(function (t) {
                        t(e);
                      }),
                      n.processReady(e)),
                    new vt(function (e) {
                      "interactive" === document.readyState
                        ? e()
                        : document.addEventListener(
                            "DOMContentLoaded",
                            function () {
                              e();
                            }
                          );
                    }).then(function () {
                      ge(t.name, le(t.name), t.name, t.version);
                    });
                })(r, e, t, n);
              }
            ),
            e.configUrl)
          ) {
            var o = n.createMark("load", "config");
            (o.end = o.start()),
              qe().loadScript(
                e.configUrl,
                {
                  timeout: 3e4,
                },
                function () {
                  o.end();
                }
              );
          }
        }
        var _t = n.g.BV,
          kt = (function (e) {
            return (
              (e &&
                e.split(",").map(function (e) {
                  return e.trim();
                })) ||
              []
            );
          })(k.disabled);

        function Ot(e, t) {
          var r = t.createMark("register", e.name);
          r.end = r.start();
          var o = new (pt())({
            name: e.name,
          });
          s.Z.registerProperty(e.name, o);
          var a = t.createMark("app", e.name),
            i = a.createMark("configure"),
            c = a.createMark("load"),
            u = a.createMark("render");
          (a.configure = i),
            (a.load = c),
            (a.render = u),
            (s.Z[e.name].perfMark = a),
            o.setErrorHandler(function (t, r) {
              return (function (e, t, r) {
                t instanceof Error || (t = new Error(t));
                var o = n.g.console;
                o && o.error && o.error(t),
                  s.Z[e]._analytics.trackError({
                    message: t.message || t,
                    stack: t.stack,
                    type: "BV Application "
                      .concat(r.event, " ")
                      .concat(t.name || "Error"),
                  }),
                  (0, $.Z)().then(function (n) {
                    (r.app = e),
                      n(t, {
                        extra: r,
                      });
                  });
              })(e.name, t, r);
            });
          var l = function () {
            var t = (s.Z[e.name]._analytics = z({
              name: e.name,
              source: "bv-loader",
            }));
            _t.global.loadUserSegment.then(function (e) {
              t.setCommonData({
                displaySegment: e,
              });
            }),
              "api" === e.name && (s.Z[e.name].analytics = t),
              kt.some(function (t) {
                return ~[e.name, e.publicName].indexOf(t);
              })
                ? H.trackEvent("Feature", {
                    type: "Used",
                    name: "AppDisabled",
                    detail1: e.name,
                  })
                : St(e, o, a),
              (l = function () {});
          };
          if (
            j.some(function (t) {
              return t === e.name;
            }) ||
            !e.defer
          )
            l();
          else {
            var f = o.configure,
              d = o.ready,
              m = o.render,
              p = function (e, t) {
                return (
                  l(),
                  (o.configure = f),
                  (o.ready = d),
                  (o.render = m),
                  o[e].apply(this, t)
                );
              };
            ["configure", "ready", "render"].forEach(function (e) {
              o[e] = function () {
                return p.call(this, e, arguments);
              };
            });
          }
          Ze(
            o,
            function () {
              return l;
            },
            a
          ),
            r.end();
        }
        _().call(pt().prototype);
        const Tt = function () {
          Ke().initConsent(
            {
              NoCookie: !0,
              bv_metrics: !1,
              bv_segment: !1,
              BVBRANDID: !1,
              BVBRANDSID: !1,
            },
            !a.Z.cookiesOptIn
          ),
            (s.Z.cookieConsent = Ke()),
            (s.Z.cookie = me());
        };
        var Ct = function () {
            var e,
              t,
              n,
              r,
              o = document.createElement("link");
            (o.rel = "preconnect"),
              (o.href =
                ((e = BV.global),
                (t = e.dataEnvironment),
                (n = e.serverEnvironment),
                (r = "".concat(
                  "qa" === n || "dev" === n ? "qa." : "stg" === t ? "stg." : "",
                  "api.bazaarvoice.com"
                )),
                "https://".concat(r, "/"))),
              (o.crossOrigin = "anonymous"),
              document.head.appendChild(o),
              setTimeout(function () {
                o && o.parentNode && o.parentNode.removeChild(o);
              }, 2e4);
          },
          Nt = n(353);
        const At = function () {
          var e =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : "",
            t = arguments.length > 1 ? arguments[1] : void 0,
            n = arguments.length > 2 ? arguments[2] : void 0,
            r = arguments.length > 3 ? arguments[3] : void 0,
            o = arguments.length > 4 ? arguments[4] : void 0;
          for (t = n = r = 0; (o = e.charCodeAt(r++)); n = (n + t) % 255)
            t = (t + o) % 255;
          return (n << 8) | t;
        };
        var Pt = n(422),
          xt = s.Z.cookie || me(),
          It = function (e, t, n) {
            var r = Pt.document.createElement("div");
            return (
              r.setAttribute("data-bv-show", "inpage_submission"),
              r.setAttribute("data-bv-product-id", e),
              n && r.setAttribute("data-bv-inpagerating", n),
              t &&
                ("ssURL" === t &&
                  H.trackEvent("Diagnostic", {
                    name: "v2ssURLReviewSubmission",
                    type: "v2ssURLReview",
                    detail1: "v2ssURLLoaded",
                  }),
                r.setAttribute("data-bv-inpagesource", t)),
              null !== a.Z &&
                void 0 !== a.Z &&
                a.Z.isSwatContainerEnabled &&
                (function () {
                  if (["bvHostedContainer", "container"].includes(C())) {
                    var e,
                      t =
                        null === (e = Pt.document) || void 0 === e
                          ? void 0
                          : e.querySelector("bv-loading-icon");
                    t && (t.hide = !0);
                  }
                })(),
              Pt.document.body.appendChild(r),
              r
            );
          },
          Rt = function () {
            if (Pt.location.search) {
              var e = new URLSearchParams(Pt.location.search);
              if ("rr_submit_review" !== e.get("bvaction")) {
                var t = e.get("bvdata");
                if (t) {
                  var n,
                    r,
                    o,
                    a,
                    i = new URLSearchParams(t);
                  if ("swat_submit_review" === i.get("action")) {
                    var s = i.get("productId"),
                      c = xt.read(
                        ((n = "inpagedata"),
                        (r = Pt.BV.global),
                        (o = r.dataEnvironment),
                        (a = r.client),
                        "bvf_".concat(n) + At(a) + ("prod" === o ? "" : "s"))
                      ),
                      u = c ? JSON.parse(c) : {};
                    It(s, u.inPageSource || "bv_loader", u.ratingValue);
                  }
                }
              } else {
                var l = e.get("bvproductId");
                It(l, "ssURL");
              }
            }
          },
          Vt = function (e) {
            if (!e.productId)
              throw new Error("BV: IMPL: No productId is defined");
            var t = (0, Ee.shadowQuerySelectorAll)(
              Pt.document.body,
              "[data-bv-show='inpage-submission']"
            );
            if (0 === t.length) It(e.productId, "BV.ui");
            else if (t[0] instanceof HTMLElement) {
              var n = "data-bv-product-id";
              String(t[0].getAttribute(n)) === String(e.productId)
                ? Pt.BV.inpage_submission.trigger(
                    "show_form",
                    0,
                    t[0],
                    e.productId,
                    "bv-loader"
                  )
                : t[0].setAttribute(n, e.productId);
            }
          };

        function Bt(e) {
          return (
            (Bt =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  }),
            Bt(e)
          );
        }
        var jt = n(422),
          Lt = "data-bv";
        var Zt = function (e) {
            var t,
              n,
              r,
              o,
              i,
              s,
              c,
              u = jt.document.createElement("div");
            if (
              (u.setAttribute("".concat(Lt, "-show"), "product_picker"),
              (e
                ? (function (e) {
                    var t = e.categoryId,
                      n = e.familyProductId,
                      r = e.preventClose,
                      o = e.campaignId,
                      a = e.inline;
                    return [
                      {
                        key: "".concat(Lt, "-category-id"),
                        value: t,
                      },
                      {
                        key: "".concat(Lt, "-family-product-id"),
                        value: n,
                      },
                      {
                        key: "".concat(Lt, "-prevent-close"),
                        value: r,
                      },
                      {
                        key: "".concat(Lt, "-inline"),
                        value: a,
                      },
                      {
                        key: "".concat(Lt, "-campaign-id"),
                        value: o,
                      },
                    ];
                  })(e)
                : ((t = new URLSearchParams(jt.location.search)),
                  (n = t.get("bvcategoryId")),
                  (r = t.get("bvfamilyProductId")),
                  (o = t.get("bvpreventClose")),
                  (i = t.get("bvdata")),
                  (s = i ? new URLSearchParams(i) : null),
                  (c = !!s && s.get("bvInlineId")),
                  [
                    {
                      key: "".concat(Lt, "-category-id"),
                      value: n,
                    },
                    {
                      key: "".concat(Lt, "-family-product-id"),
                      value: r,
                    },
                    {
                      key: "".concat(Lt, "-prevent-close"),
                      value: o,
                    },
                    {
                      key: "".concat(Lt, "-inline"),
                      value: c,
                    },
                  ])
              ).forEach(function (e) {
                return e.value && u.setAttribute("".concat(e.key), e.value);
              }),
              e)
            ) {
              var l = e.contentContainerDiv,
                f = e.doShowContent,
                d =
                  "string" == typeof l
                    ? shadowQuerySelectorAll(document, "#".concat(l))[0]
                    : "object" === Bt(l) && l instanceof HTMLElement
                    ? l
                    : null;
              d
                ? d.appendChild(u)
                : jt.document && jt.document.body.appendChild(u),
                f && "function" == typeof e.doShowContent && f();
            } else
              null !== a.Z &&
                void 0 !== a.Z &&
                a.Z.isSwatContainerEnabled &&
                (function () {
                  if (["bvHostedContainer", "container"].includes(C())) {
                    var e,
                      t =
                        null === (e = jt.document) || void 0 === e
                          ? void 0
                          : e.querySelector("bv-loading-icon");
                    t && (t.hide = !0);
                  }
                })(),
                jt.document && jt.document.body.appendChild(u);
          },
          Dt = function (e) {
            if (jt.location.search || e) {
              var t =
                "rr_submit_generic" ===
                new URLSearchParams(jt.location.search).get("bvaction");
              (t || e) &&
                (t &&
                  H.trackEvent("Diagnostic", {
                    name: "v2ssURLGenericReviewSubmission",
                    type: "v2ssURLReview",
                    detail1: "v2ssURLLoaded",
                  }),
                Zt(e));
            }
          };

        function Mt(e) {
          return (
            (Mt =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  }),
            Mt(e)
          );
        }
        var qt = function (e) {
          return "string" == typeof e
            ? (0, Ee.shadowQuerySelectorAll)(document, "#".concat(e))[0]
            : "object" === Mt(e) && e instanceof HTMLElement
            ? e
            : null;
        };

        function Ut(e, t) {
          return (
            (function (e) {
              if (Array.isArray(e)) return e;
            })(e) ||
            (function (e, t) {
              var n =
                null == e
                  ? null
                  : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                    e["@@iterator"];
              if (null != n) {
                var r,
                  o,
                  a,
                  i,
                  s = [],
                  c = !0,
                  u = !1;
                try {
                  if (((a = (n = n.call(e)).next), 0 === t)) {
                    if (Object(n) !== n) return;
                    c = !1;
                  } else
                    for (
                      ;
                      !(c = (r = a.call(n)).done) &&
                      (s.push(r.value), s.length !== t);
                      c = !0
                    );
                } catch (e) {
                  (u = !0), (o = e);
                } finally {
                  try {
                    if (
                      !c &&
                      null != n.return &&
                      ((i = n.return()), Object(i) !== i)
                    )
                      return;
                  } finally {
                    if (u) throw o;
                  }
                }
                return s;
              }
            })(e, t) ||
            (function (e, t) {
              if (!e) return;
              if ("string" == typeof e) return Ft(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return Ft(e, t);
            })(e, t) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()
          );
        }

        function Ft(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        var Wt = "data-bv",
          zt = function (e, t) {
            var r = t.productId,
              o = t.contentContainerDiv,
              a = t.doShowContent,
              i = (t.summaryContainerDiv, t.enableSeo);
            if (!r || !o)
              throw Error(
                "Required parameters are missing productId or contentContainerDiv"
              );
            var s = n.g.document.createElement("div");
            s.setAttribute("".concat(Wt, "-show"), e),
              s.setAttribute("".concat(Wt, "-product-id"), r),
              i && s.setAttribute("".concat(Wt, "-seo"), !0);
            var c = qt(o);
            if (!c) throw Error("Container not present in the document");
            c.appendChild(s), "function" == typeof a && a();
          },
          Ht = function (e, t, r) {
            var o = r.questionId,
              a = r.contentContainerDiv,
              i = (function (e, t) {
                var n = t.submissionFormType,
                  r = t.productId,
                  o = t.questionId,
                  a = t.contentContainerDiv;
                e.setAttribute("data-bv-product-id", r),
                  "answer" === n && e.setAttribute("data-bv-question-id", o);
                var i = null;
                a && (i = qt(a)),
                  "question" === n &&
                    e.setAttribute(
                      "data-bv-question-submission-form-type",
                      i ? "inline" : "lightbox"
                    );
                var s = "data-bv-submission-source";
                return (
                  e.setAttribute("data-bv-show", "questions"),
                  e.setAttribute("data-bv-submission-type", n),
                  e.setAttribute(s, "BV.ui"),
                  [e, s, i]
                );
              })(n.g.document.createElement("div"), {
                submissionFormType: e,
                productId: t,
                questionId: o,
                contentContainerDiv: a,
              }),
              s = Ut(i, 3),
              c = s[0],
              u = s[1],
              l = s[2],
              f = (0, Ee.shadowQuerySelectorAll)(
                n.g.document.body,
                "[".concat(u, "='BV.ui']")
              );
            return (
              f.length > 0 && f[0] instanceof HTMLElement && f[0].remove(),
              l && l instanceof HTMLElement
                ? l.appendChild(c)
                : n.g.document.body.appendChild(c),
              c
            );
          },
          $t = function (e) {
            var t = e.productId,
              r = e.contentContainerDiv,
              o = (0, Ee.shadowQuerySelectorAll)(
                n.g.document.body,
                "[data-bv-show='questions']"
              ),
              a =
                o.length > 0 &&
                o[0] instanceof HTMLElement &&
                o[0].dataset.productId === t;
            if (n.g.BV.swat_questions && a)
              n.g.BV.swat_questions.trigger("show_qform", {
                source: "BV.ui",
              });
            else {
              var i = Ht("question", t, {
                contentContainerDiv: r,
              });
              n.g.BV.globalEvents.once(
                "remove_swat_question_submission",
                function () {
                  i && i.remove();
                }
              );
            }
          },
          Qt = function (e) {
            var t = e.questionId,
              r = e.productId,
              o = Ht("answer", r, {
                questionId: t,
              });
            n.g.BV.globalEvents.once(
              "remove_swat_answer_submission",
              function () {
                o && o.remove();
              }
            );
          },
          Jt = n(920);

        function Kt(e) {
          return (
            (Kt =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  }),
            Kt(e)
          );
        }
        var Gt = ["rr", "qa"],
          Xt = "submit_question",
          Yt = "submit_answer",
          en = "submit_review",
          tn = "show_questions",
          nn = "show_reviews",
          rn = "submit_generic",
          on = [nn, rn, en],
          an = [tn, Xt, Yt];

        function sn() {}

        function cn(e, t) {
          try {
            if (
              (H.trackEvent("Diagnostic", {
                name: "configure",
                type: "handler",
                detail1: "configureEventCallbacks",
              }),
              t && "object" === Kt(t) && !Array.isArray(t) && t.events)
            ) {
              var n;
              if (!e || "string" != typeof e || "global" !== e)
                throw new Error(
                  "IMPL: event handlers can only be set in global config"
                );
              var r = t.events;
              if (!r || "object" !== Kt(r) || Array.isArray(r))
                throw new Error(
                  "IMPL: events property in global config must be an object"
                );
              for (var o in r) {
                var a = r[o];
                "function" == typeof a && this.on(o, a);
              }
            }
          } catch (n) {
            console.error(n);
          }
        }

        function un(e, t, r) {
          var o;
          H.trackEvent("Diagnostic", {
            name: "ui",
            type: "handler",
            detail1: t,
            detail2: r.productId,
          });
          try {
            if (!Gt.includes(e)) throw Error("Scope not supported.");
            if ("rr" === e && !on.includes(t))
              throw Error("Incorrect scope and type combinations for scope rr");
            if ("qa" === e && !an.includes(t))
              throw Error("Incorrect scope and type combinations for scope qa");
            switch (e) {
              case "rr":
                t === nn
                  ? (zt("reviews", r),
                    (o = new Jt(function (e) {
                      n.g.BV.globalEvents.on("rr_show_reviews", function (t) {
                        e(t);
                      });
                    })))
                  : t === rn
                  ? Dt(r)
                  : t === en &&
                    (Vt(r),
                    (o = new Jt(function (e) {
                      n.g.BV.globalEvents.on("rr_submit_review", function (t) {
                        e(t);
                      });
                    })));
                break;
              case "qa":
                t === tn
                  ? (zt("questions", r),
                    (o = new Jt(function (e) {
                      n.g.BV.globalEvents.on("rr_show_questions", function (t) {
                        e(t);
                      });
                    })))
                  : t === Xt
                  ? ($t(r),
                    (o = new Jt(function (e) {
                      n.g.BV.globalEvents.on(
                        "qa_submit_question",
                        function (t) {
                          e(t);
                        }
                      );
                    })))
                  : t === Yt &&
                    (Qt(r),
                    (o = new Jt(function (e) {
                      n.g.BV.globalEvents.on("qa_submit_answer", function (t) {
                        e(t);
                      });
                    })));
            }
            return o;
          } catch (e) {
            console.error(e);
          }
        }
        const ln = function () {
          _().call(sn.prototype);
          var e = new sn();
          (s.Z.globalEvents = e),
            (s.Z.configure = cn.bind(e)),
            (s.Z.ui = un.bind(e));
        };
        var fn = n(422),
          dn = n.n(fn),
          mn = ["rr_submit_review", "rr_submit_generic"],
          pn = a.Z.isSwatContainerEnabled,
          vn = a.Z.isSwatQuestionsEnabled,
          hn = a.Z.isSwatReviewsEnabled,
          bn = [
            "REVIEW_CONFIRMATION",
            "QUESTION_CONFIRMATION",
            "ANSWER_CONFIRMATION",
            "COMMENT_CONFIRMATION",
          ];
        var gn,
          yn,
          wn = [
            "REVIEW_APPROVED",
            "REVIEW_RESPONSE",
            "REVIEW_COMMENTED",
            "COMMENT_APPROVED",
          ],
          En = ["QUESTION_APPROVED", "QUESTION_ANSWERED", "ANSWER_APPROVED"],
          Sn =
            ((gn = {
              container: Ve,
              bvhostedcontainer: Re,
            }),
            (yn = C()) && ["container", "bvhostedcontainer"].includes(yn)
              ? gn[yn]
              : Be),
          _n = "bvmessageType",
          kn = function (e) {
            H.trackEvent("Feature", {
              type: xe,
              bvProduct: Pe,
              name: Ie,
              bvProductVersion: a.Z.scoutVersion,
              notificationid:
                e.get("bvnotificationId") || e.get("bvnotificationid") || "",
              detail1: e.has(_n) && e.get(_n),
              detail2: Sn,
            });
          },
          On = {
            isSiteAuth: function (e) {
              return (
                (mn.includes(e.get("bvaction")) || e.has("bveventid")) && pn
              );
            },
            isUnsubscribePage: function (e) {
              return e.has("bv_unsubtoken") && e.has("emailtype");
            },
            isReviewsContentDeepLink: function (e) {
              var t = e.has(_n) && wn.includes(e.get(_n)) && hn;
              return t && kn(e), t;
            },
            isVerificationType: function (e) {
              var t, n, r;
              return (
                e &&
                  e instanceof URLSearchParams &&
                  ((t = e.get(_n)),
                  (n = e.get("bv_authtoken")),
                  t && bn.includes(t) && n && (r = !0)),
                !!r &&
                  (H.trackEvent("Feature", {
                    name: "DeepLinkVerificationRedirect",
                    type: "Shown",
                    detail1: "Deep Link Verification v2",
                    detail2: t,
                  }),
                  !0)
              );
            },
            isQuestionsAppDeepLink: function (e) {
              var t = e.has(_n) && En.includes(e.get(_n)) && vn;
              return t && kn(e), t;
            },
          },
          Tn = {
            isSiteAuth: function () {
              return [
                {
                  key: "data-bv-type",
                  value: "siteAuthRedirect",
                },
                {
                  key: "data-bv-hosted-page",
                  value: "bvHostedContainer" === C(),
                },
              ];
            },
            isUnsubscribePage: function (e) {
              return [
                {
                  key: "data-bv-type",
                  value: "unsubscribe",
                },
                {
                  key: "data-bv-unsubtoken",
                  value: e.get("bv_unsubtoken"),
                },
                {
                  key: "data-bv-emailtype",
                  value: e.get("emailtype"),
                },
              ];
            },
            isReviewsContentDeepLink: function () {
              return [
                {
                  key: "data-bv-type",
                  value: "emailMessageType",
                },
                {
                  key: "data-bv-detail1",
                  value: Sn,
                },
              ];
            },
            isVerificationType: function (e) {
              return [
                {
                  key: "data-bv-messagetype",
                  value: e.get(_n),
                },
                {
                  key: "data-bv-authtoken",
                  value: e.get("bv_authtoken"),
                },
              ];
            },
            isQuestionsAppDeepLink: function () {
              return [
                {
                  key: "data-bv-type",
                  value: "emailMessageType",
                },
                {
                  key: "data-bv-detail1",
                  value: Sn,
                },
              ];
            },
          };

        function Cn(e) {
          var t = (function (e) {
            return Object.keys(On).find(function (t) {
              return On[t](e);
            });
          })(e);
          return (
            !!t &&
            ((function () {
              var e =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : [],
                t = dn().document.createElement("div");
              t.setAttribute("data-bv-show", "container"),
                e.forEach(function (e) {
                  return t.setAttribute(e.key, e.value);
                }),
                dn().document.body.appendChild(t);
            })(Tn[t](e)),
            !0)
          );
        }
        const Nn = function () {};
        var An = n(920);

        function Pn(e, t) {
          return (
            (function (e) {
              if (Array.isArray(e)) return e;
            })(e) ||
            (function (e, t) {
              var n =
                null == e
                  ? null
                  : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                    e["@@iterator"];
              if (null != n) {
                var r,
                  o,
                  a,
                  i,
                  s = [],
                  c = !0,
                  u = !1;
                try {
                  if (((a = (n = n.call(e)).next), 0 === t)) {
                    if (Object(n) !== n) return;
                    c = !1;
                  } else
                    for (
                      ;
                      !(c = (r = a.call(n)).done) &&
                      (s.push(r.value), s.length !== t);
                      c = !0
                    );
                } catch (e) {
                  (u = !0), (o = e);
                } finally {
                  try {
                    if (
                      !c &&
                      null != n.return &&
                      ((i = n.return()), Object(i) !== i)
                    )
                      return;
                  } finally {
                    if (u) throw o;
                  }
                }
                return s;
              }
            })(e, t) ||
            (function (e, t) {
              if (!e) return;
              if ("string" == typeof e) return xn(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return xn(e, t);
            })(e, t) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()
          );
        }

        function xn(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        n(183);
        var In = n(422);
        const Rn = function () {
          var e = In.document,
            t = ne("bv_loader");
          Tt(), dt(), (t.end = t.start());
          In.navigator.userAgent.indexOf("MSIE") > -1 ||
            In.navigator.userAgent.indexOf("Trident/");
          if (
            ((s.Z.privacy = it),
            at(Ye),
            ln(),
            (s.Z.pixel = z({
              commonData: {
                bvProduct: "pixel",
              },
              name: "pixel",
              source: "bv-loader",
            })),
            a.Z.isCurationsEnabled)
          ) {
            In.crl8 = In.crl8 = In.crl8 || {};
            var n = !1,
              r = [],
              o = function () {
                (n = !0),
                  r.forEach(function (e) {
                    e();
                  });
              };
            In.crl8.ready = function (e) {
              n ? e() : r.push(e);
            };
          }
          a.Z.apps.forEach(function (e) {
            return Ot(e, t);
          }),
            s.Z.curations && s.Z.curations.on("curations_loaded", o),
            E({
              selector: "[data-bv-show]",
              attributes: Ae,
              callback: function (e, t) {
                var n = [t];
                e === l
                  ? (De(n), Te(n))
                  : e === f
                  ? Ce(n)
                  : (De(n), Ce(n), Te(n, !0));
              },
            }),
            (In.$BV && "ui" in In.$BV) || a.Z.isPreview || (In.$BV = $e());
          var i,
            c = new URLSearchParams(In.location.search);
          (("container" === C() ||
            "bvHostedContainer" === C() ||
            c.get("bvMessageType") ||
            c.get("bvmessageType")) &&
            (a.Z.isConversations
              ? (function () {
                  var e = new URLSearchParams(dn().location.search);
                  !Cn(e) &&
                    mn.includes(e.get("bvaction")) &&
                    "container" === C() &&
                    dn().$BV.container("global", {});
                })()
              : In.$BV.ui("submission_container", {})),
          (0, Nt.M)(),
          L) &&
            (In[L]
              ? v(In[L])
              : Object.defineProperty(In, L, {
                  get: function () {
                    return i;
                  },
                  set: function (e) {
                    (i = e), v(e);
                  },
                }));
          t.end();
          var u = Pn(t.measures, 1)[0],
            d = u.duration,
            m = u.startTime,
            p = m + d;
          try {
            H.trackEvent("Diagnostic", {
              name: "timeToRunScout",
              type: "Performance",
              startTime: m.toFixed(4),
              endTime: p.toFixed(4),
              elapsedMs: d.toFixed(4),
            });
          } catch (e) {}

          function v(e) {
            if ("function" != typeof e)
              throw Error("The BV Callback must be a function.");
            setTimeout(function () {
              e.call(null, s.Z);
            });
          }
          be &&
            (new An(function (t) {
              "interactive" === e.readyState
                ? t()
                : e.addEventListener("DOMContentLoaded", function () {
                    t();
                  });
            }).then(function () {
              ge(
                "page",
                (function () {
                  var e = ae.devicePixelRatio,
                    t = ae.innerHeight,
                    n = ae.innerWidth,
                    r = ae.navigator,
                    o = {
                      devicePixelRatio: e,
                      screenHeight: t,
                      screenWidth: n,
                    };
                  r.connection &&
                    ((o.effectiveType = r.connection.effectiveType),
                    (o.downlink = r.connection.downlink));
                  var a = J.getEntriesByType("navigation").shift();
                  return (
                    a &&
                      [
                        "connectEnd",
                        "connectStart",
                        "domainLookupStart",
                        "domainLookupEnd",
                        "domComplete",
                        "domInteractive",
                        "domContentLoadedEventStart",
                        "fetchStart",
                        "loadEventEnd",
                        "requestStart",
                        "responseStart",
                        "responseEnd",
                        "secureConnectionStart",
                      ].forEach(function (e) {
                        o[e] = ce(a[e]);
                      }),
                    ie(se(o))
                  );
                })()
              ),
                ge(
                  "bv-loader",
                  (function () {
                    var e = {},
                      t = J.getEntriesByType("resource")
                        .filter(function (e) {
                          return !!e.name.match(re.Z.bvLoaderRegex);
                        })
                        .shift();
                    t &&
                      [
                        "connectEnd",
                        "connectStart",
                        "domainLookupStart",
                        "domainLookupEnd",
                        "domComplete",
                        "domInteractive",
                        "domContentLoadedEventStart",
                        "fetchStart",
                        "loadEventEnd",
                        "requestStart",
                        "responseStart",
                        "responseEnd",
                        "secureConnectionStart",
                      ].forEach(function (n) {
                        e[n] = ce(t[n]);
                      });
                    var n,
                      r,
                      o = ((n = "requestedApp"),
                      (r = a.Z.apps.map(function (e) {
                        return e.name;
                      })),
                      r.map(function (e) {
                        return {
                          name: n,
                          value: e,
                        };
                      })).concat(se(e));
                    return ie(o);
                  })()
                );
            }),
            window.addEventListener("unload", function () {
              for (var e in (ge("resources", fe()), In.BV._render.layouts))
                ge("render", ue(e, !0), e);
            }));
          var h = t.createMark("preconnectMark").start();
          Ct(), h(), Rt(), Dt(), Nn();
        };
      },
      690: (e, t, n) => {
        "use strict";
        n.d(t, {
          Z: () => r,
        });
        const r = {
          deployment: {
            client: "betterhealth",
            site: "main_site",
            environment: "production",
            locale: "en_US",
          },
          dataEnvironment: "prod",
          serverEnvironment: "prod",
          vpc: "prod",
          piiDataRegion: "unitedStates",
          cookiesOptIn: !1,
          displayCode: "23837",
          domains: [
            {
              firstPartyCookieEnabled: !0,
              domain: ".betterhealth.com",
            }
            ,
            {
              firstPartyCookieEnabled: !0,
              domain: ".bazaarvoice.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain:
                ".feature-single-checkout-aij3ixa-etrb5fanbboxu.eu-5.magentosite.cloud",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: ".mcstaging.betteryourhealth.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: ".betteryourhealth.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain:
                ".bh.bundle-test-env-x5ttyda-etrb5fanbboxu.eu-5.magentosite.cloud",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: ".renewlife.betteryourhealth.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: ".neocell.betteryourhealth.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: ".naturalvitality.betteryourhealth.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: ".rainbowlight.betteryourhealth.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain:
                ".rnl.bh.subdomains-byh-gv2dwaa-etrb5fanbboxu.eu-5.magentosite.cloud",
            },
            {
              firstPartyCookieEnabled: !0,
              domain:
                ".bh.subdomains-byh-gv2dwaa-etrb5fanbboxu.eu-5.magentosite.cloud",
            },
            {
              firstPartyCookieEnabled: !0,
              domain:
                ".nv.bh.subdomains-byh-gv2dwaa-etrb5fanbboxu.eu-5.magentosite.cloud",
            },
            {
              firstPartyCookieEnabled: !0,
              domain:
                ".nc.bh.subdomains-byh-gv2dwaa-etrb5fanbboxu.eu-5.magentosite.cloud",
            },
            {
              firstPartyCookieEnabled: !0,
              domain:
                ".rbl.bh.subdomains-byh-gv2dwaa-etrb5fanbboxu.eu-5.magentosite.cloud",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: ".byh-stage.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: ".renewlife.byh-stage.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: ".naturalvitality.byh-stage.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: ".neocell.byh-stage.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: ".rainbowlight.byh-stage.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: "translate.googleusercontent.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: "webcache.googleusercontent.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: "translate.baiducontent.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: ".bazaarvoice.com",
            },
            {
              firstPartyCookieEnabled: !0,
              domain: "localhost",
            },
          ],
          scoutVersion: "13.24.3",
          splitTestingEnabled: !1,
          isConversations: !0,
          isPreview: !1,
          legacyScoutUrl:
            "https://display.ugc.bazaarvoice.com/static/betterhealth/main_site/en_US/bvapi.js",
          paths: {
            root: "https://apps.bazaarvoice.com",
            splitTests: "https://apps.bazaarvoice.com/splitTests.json",
            componentTemplate:
              "https://apps.bazaarvoice.com/components/components-<%= version %>.min.js",
            renderTemplate:
              "https://apps.bazaarvoice.com/render/render-<%= version %>.min.js",
            layoutRoot:
              "https://apps.bazaarvoice.com/deployments/betterhealth/main_site/production/en_US/layouts",
          },
          render: {},
          webAnalyticsIntegrationConfigs: [],
          loadSwatAppsInShadowDOM: !1,
          isSwatContainerEnabled: !1,
          isSwatReviewsEnabled: !0,
          isContextualCommerceEnabled: !1,
          apps: [
            {
              name: "api",
              version: "0.8.2",
              defer: !1,
              hasConfig: !0,
              sourcePath: "https://apps.bazaarvoice.com/apps/api/api-0.8.2.js",
              legacyPath: null,
              publicName: "api",
              configUrl:
                "https://apps.bazaarvoice.com/deployments/betterhealth/main_site/production/en_US/api-config.js",
            },
            {
              name: "inline_ratings",
              version: "2.4.7",
              defer: !0,
              hasConfig: !0,
              sourcePath:
                "https://apps.bazaarvoice.com/apps/inline_ratings/inline_ratings-2.4.7.js",
              legacyPath: null,
              publicName: "inline_rating",
              configUrl:
                "https://apps.bazaarvoice.com/deployments/betterhealth/main_site/production/en_US/inline_ratings-config.js",
            },
            {
              name: "inpage_submission",
              version: "4.12.3",
              defer: !0,
              hasConfig: !0,
              sourcePath:
                "https://apps.bazaarvoice.com/apps/inpage_submission/inpage_submission-4.12.3.js",
              legacyPath: null,
              publicName: "inpage_submission",
              configUrl:
                "https://apps.bazaarvoice.com/deployments/betterhealth/main_site/production/en_US/inpage_submission-config.js",
            },
            {
              name: "rating_summary",
              version: "2.64.1",
              defer: !0,
              hasConfig: !0,
              sourcePath:
                "https://apps.bazaarvoice.com/apps/rating_summary/rating_summary-2.64.1.js",
              legacyPath: null,
              publicName: "rating_summary",
              configUrl:
                "https://apps.bazaarvoice.com/deployments/betterhealth/main_site/production/en_US/rating_summary-config.js",
            },
            {
              name: "ratings",
              version: "0.1.23",
              defer: !0,
              hasConfig: !0,
              sourcePath:
                "https://apps.bazaarvoice.com/apps/ratings/ratings-0.1.23.js",
              legacyPath: null,
              publicName: "ratings",
              configUrl:
                "https://apps.bazaarvoice.com/deployments/betterhealth/main_site/production/en_US/ratings-config.js",
            },
            {
              name: "swat-submission",
              version: "4.8.3",
              defer: !0,
              hasConfig: !0,
              sourcePath:
                "https://apps.bazaarvoice.com/apps/swat-submission/swat-submission-4.8.3.js",
              legacyPath: null,
              publicName: "multi_submission",
              configUrl:
                "https://apps.bazaarvoice.com/deployments/betterhealth/main_site/production/en_US/swat-submission-config.js",
            },
            {
              name: "swat_container",
              version: "1.3.5",
              defer: !0,
              hasConfig: !0,
              sourcePath:
                "https://apps.bazaarvoice.com/apps/swat_container/swat_container-1.3.5.js",
              legacyPath: null,
              publicName: "container",
              configUrl:
                "https://apps.bazaarvoice.com/deployments/betterhealth/main_site/production/en_US/swat_container-config.js",
            },
            {
              name: "swat_reviews",
              version: "6.24.23",
              defer: !0,
              hasConfig: !0,
              sourcePath:
                "https://apps.bazaarvoice.com/apps/swat_reviews/swat_reviews-6.24.23.js",
              legacyPath: null,
              publicName: "reviews",
              configUrl:
                "https://apps.bazaarvoice.com/deployments/betterhealth/main_site/production/en_US/swat_reviews-config.js",
            },
          ],
        };
      },
      318: (e, t, n) => {
        "use strict";
        n.d(t, {
          Z: () => l,
        });
        var r = n(530),
          o = n.n(r),
          a = n(690),
          i = n(422),
          s = console.warn.bind(console),
          c = [
            "API_BASE_URL",
            "Date",
            "_bvapijs",
            "_internal",
            "_options",
            "_staticAssetRegistry",
            "configure",
            "cookie",
            "cookieConsent",
            "define",
            "easyXDM",
            "extensions",
            "global",
            "initialData",
            "name",
            "options",
            "performance",
            "pixel",
            "privacy",
            "_private",
            "globalEvents",
            "registerProperty",
            "_render",
            "requestAnimationFrame",
            "require",
            "requirejs",
            "serverRender",
            "_spotlightsConfig",
            "Spotlights",
            "staticAssetLoader",
            "ud",
            "ui",
          ].concat(
            a.Z.apps.map(function (e) {
              return e.name;
            })
          );
        if ("Proxy" in i) {
          var u = i.Proxy;
          i.BV = new u(i.BV || {}, {
            set: function (e, t, n) {
              return (
                ~c.indexOf(t) ||
                  s(
                    "Unexpected property '".concat(
                      t,
                      "' assigned to window.BV. Valid assignment to the BV variable requires approval from the BV Loader Team."
                    )
                  ),
                (e[t] = n),
                !0
              );
            },
          });
        }
        const l = o().namespace("BV");
      },
      334: (e, t, n) => {
        "use strict";
        n.d(t, {
          Z: () => a,
        });
        var r = n(690),
          o = new RegExp("/deployments/([^/]+)/(?:[^/]+/){3}bv\\.js");
        const a = {
          appNameRegex: function (e) {
            return new RegExp(
              ""
                .concat(r.Z.paths.root, "/apps/")
                .concat(e, "/")
                .concat(e, "-[^/]+.js")
            );
          },
          layoutNameRegex: function (e) {
            return new RegExp(
              "".concat(r.Z.paths.layoutRoot, "/").concat(e, ".json")
            );
          },
          renderRegex: r.Z.deployment.local
            ? new RegExp("render.js")
            : new RegExp("".concat(r.Z.paths.root, "/render/render-[^/]+.js")),
          bvLoaderRegex: o,
          parseClient: function (e) {
            var t = o.exec(e);
            if (t) return t[1];
          },
          errorReportPath: "".concat(r.Z.paths.root, "/errors"),
          errorReportProxy: "https://observability".concat(
            "prod" === r.Z.serverEnvironment ? ".prod" : ".qa",
            ".bazaarvoice.com/error"
          ),
        };
      },
      183: (e, t, n) => {
        "use strict";
        n.r(t);
        var r = n(318),
          o = n(886),
          a = n(64);
        (r.Z._private = {}),
          (0, o.Z)(r.Z._private, {
            ponyfills: r.Z.global.ponyfills,
            SystemJS: r.Z.global.SystemJS,
            loadUserSegment: r.Z.global.loadUserSegment,
            errorReporter: a.Z,
          }),
          Object.freeze(r.Z._private);
      },
      64: (e, t, n) => {
        "use strict";
        n.d(t, {
          Z: () => y,
        });
        var r = n(753),
          o = n.n(r),
          a = n(690),
          i = n(390),
          s = n(304),
          c = n(334),
          u = n(353);

        function l(e) {
          return (
            (l =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  }),
            l(e)
          );
        }
        var f = function () {
            var e = new WeakSet();
            return function (t, n) {
              if ("object" === l(n) && null !== n) {
                if (e.has(n)) return;
                e.add(n);
              }
              return n;
            };
          },
          d = n(920),
          m = n(147).i8,
          p = n(422),
          v = 1e4,
          h = ["inpage_submission", "swat_reviews", "swat_questions"];

        function b(e) {
          var t =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {},
            n = t.extra,
            r = t.renderVersion,
            o = t.componentsVersion,
            a = t.component;
          return (0, u.M)()
            .then(function () {
              return g(e, {
                extra: n,
                renderVersion: r,
                componentsVersion: o,
                component: a,
              });
            })
            .catch(function () {
              return g(e, {
                extra: n,
                renderVersion: r,
                componentsVersion: o,
                component: a,
              });
            })
            .then(function (e) {
              return (
                (t = e),
                (n = new XMLHttpRequest()),
                (o = t.extra ? t.extra.app : ""),
                (r = !!h.includes(o)),
                new d(function (e, o) {
                  (n.onreadystatechange = function () {
                    if (n.readyState === XMLHttpRequest.DONE)
                      if (200 === n.status) {
                        var t;
                        try {
                          t = JSON.parse(n.responseText);
                        } catch (e) {
                          o(
                            "Unable to JSON.parse server response: ".concat(
                              n.responseText,
                              "."
                            )
                          );
                        }
                        e(t);
                      } else o("The call to the server was not successful.");
                  }),
                    n.open(
                      "POST",
                      r ? c.Z.errorReportProxy : c.Z.errorReportPath
                    ),
                    (n.timeout = v),
                    (n.ontimeout = function () {
                      n.abort();
                    }),
                    n.setRequestHeader("Content-Type", "application/json"),
                    n.send(JSON.stringify(t, f()));
                })
              );
              var t, n, r, o;
            });
        }

        function g(e) {
          var t =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {},
            n = t.extra,
            r = t.renderVersion,
            c = t.componentsVersion,
            u = t.component,
            l = (function (e) {
              var t = (function (e) {
                var t;
                try {
                  t = o().parse(e);
                } catch (e) {
                  return;
                }
                return {
                  frames: t.map(function (e) {
                    return {
                      filename: e.fileName,
                      function: e.functionName,
                      lineno: e.lineNumber,
                      colno: e.columnNumber,
                    };
                  }),
                };
              })(e);
              return {
                type: e.name,
                value: e.message,
                stacktrace: t,
              };
            })(e),
            f = {
              timestamp: new Date(Date.now()).toISOString(),
              logger: "bv.js",
              platform: "javascript",
              sdk: {
                name: "bv-loader",
                version: m,
              },
              level: "error",
              release: m,
              tags: {
                components_release: c,
                bv_loader_release: m,
                render_release: r,
                client: a.Z.deployment.client,
                deployment_zone: a.Z.deployment.site,
                data_environment: a.Z.dataEnvironment,
                locale: a.Z.deployment.locale,
                component: u,
                load_id: p.BVA ? p.BVA.loadId : void 0,
              },
              environment: a.Z.serverEnvironment,
              exception: l,
              extra: n,
            },
            d = (0, i.detect)();
          return (
            d &&
              (f.contexts = {
                browser: {
                  name: d.name,
                  version: d.version,
                },
              }),
            (0, s.vd)()
              .then(function (e) {
                Object.defineProperty(f.tags, "bv_segment", {
                  value: e,
                });
              })
              .then(function () {
                return f;
              })
          );
        }
        const y = function () {
          return new d(function (e) {
            e(b);
          });
        };
      },
      886: (e, t, n) => {
        "use strict";

        function r(e, t) {
          Object.keys(t).forEach(function (n) {
            void 0 !== t[n] &&
              Object.defineProperty(e, n, {
                value: t[n],
              });
          });
        }
        n.d(t, {
          Z: () => r,
        });
      },
      304: (e, t, n) => {
        "use strict";
        n.d(t, {
          vd: () => _,
        });
        var r = n(974),
          o = n.n(r),
          a = n(318),
          i = n(690),
          s = n(920),
          c = 1e4,
          u = new Map();
        var l = n(920);

        function f(e, t) {
          return (
            (function (e) {
              if (Array.isArray(e)) return e;
            })(e) ||
            (function (e, t) {
              var n =
                null == e
                  ? null
                  : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                    e["@@iterator"];
              if (null != n) {
                var r,
                  o,
                  a,
                  i,
                  s = [],
                  c = !0,
                  u = !1;
                try {
                  if (((a = (n = n.call(e)).next), 0 === t)) {
                    if (Object(n) !== n) return;
                    c = !1;
                  } else
                    for (
                      ;
                      !(c = (r = a.call(n)).done) &&
                      (s.push(r.value), s.length !== t);
                      c = !0
                    );
                } catch (e) {
                  (u = !0), (o = e);
                } finally {
                  try {
                    if (
                      !c &&
                      null != n.return &&
                      ((i = n.return()), Object(i) !== i)
                    )
                      return;
                  } finally {
                    if (u) throw o;
                  }
                }
                return s;
              }
            })(e, t) ||
            (function (e, t) {
              if (!e) return;
              if ("string" == typeof e) return d(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return d(e, t);
            })(e, t) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()
          );
        }

        function d(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        var m = n(422),
          p = 14,
          v = 864e5,
          h = 60 * v,
          b = "bv_segment",
          g = "bv_segment",
          y = Math.random(),
          w = a.Z.cookie || o();

        function E() {
          return (function (e) {
            var t = u.get(e);
            if (t) return t;
            var n = new XMLHttpRequest();
            return (
              (t = new s(function (t, r) {
                (n.onreadystatechange = function () {
                  if (n.readyState === XMLHttpRequest.DONE)
                    if (200 === n.status) {
                      var e;
                      try {
                        e = JSON.parse(n.responseText);
                      } catch (e) {
                        r(
                          "Unable to JSON.parse server response: ".concat(
                            n.responseText,
                            "."
                          )
                        );
                      }
                      t(e);
                    } else r("The call to the server was not successful.");
                }),
                  n.open("GET", e, !0),
                  (n.timeout = c),
                  (n.ontimeout = function () {
                    n.abort();
                  }),
                  n.send();
              })),
              u.set(e, t),
              t
            );
          })(i.Z.paths.splitTests).then(
            function (e) {
              return e.tests;
            },
            function () {
              return [];
            }
          );
        }

        function S(e) {
          var t,
            n = [],
            r = [];
          try {
            e.forEach(function (e) {
              var t;
              ((t = e),
              new Date(t.start).getTime() + (t.duration || h) < Date.now() ||
                t.forceExpire)
                ? r.push(e)
                : n.push(e);
            });
            var o = n.filter(u),
              i = n.filter(function (e) {
                return !e.clients;
              }),
              s = o.length > 0 ? o : i;
            s.sort(function (e, t) {
              return new Date(e.start) - new Date(t.start);
            }),
              (t = s.shift());
            var c = r.filter(u);
            c.length > 0 &&
              !t &&
              (c.sort(function (e, t) {
                return new Date(t.start) - new Date(e.start);
              }),
              ((t = c.shift()).inActive = !0));
          } catch (e) {
            throw new Error(
              "Something went wrong when choosing a split test.\n      Please ensure that all defined tests are valid. ".concat(
                e
              )
            );
          }
          return t;

          function u(e) {
            var t = e.clients,
              n = e.deploymentzones;
            if (!t) return !1;
            if (n) {
              var r = -1 !== n.indexOf(a.Z.global.siteId),
                o = -1 !== t.indexOf(a.Z.global.client);
              return r && o;
            }
            return -1 !== t.indexOf(a.Z.global.client);
          }
        }

        function _() {
          if (!i.Z.splitTestingEnabled) return l.resolve(k());
          var e,
            t =
              ((e = g),
              m.location.search
                .substring(1)
                .split("&")
                .filter(function (t) {
                  return t.split("=")[0] === e;
                })
                .map(function (e) {
                  return e.split("=")[1];
                })[0]);
          if (t) return l.resolve(t);
          var n = w.read(b);
          if (n) {
            var r;
            try {
              r = JSON.parse(n);
            } catch (e) {}
            if (r) {
              var o = r.segment;
              if (o) {
                var a = l.resolve(o);
                return (
                  a.then(function () {
                    return (
                      (e = r.testId),
                      void E().then(function (t) {
                        var n = f(
                          t.filter(function (t) {
                            return t.id === e;
                          }),
                          1
                        )[0];
                        n && n.forceExpire && w.remove(b);
                      })
                    );
                    var e;
                  }),
                  a
                );
              }
            }
          }
          return E()
            .then(S)
            .then(function (e) {
              if (!e) return k();
              if (e && e.inActive) return k(e);
              var t = k(e),
                n = new Date(e.start).getTime();
              if (!(n <= Date.now())) return t;
              var r = (function (e) {
                return (
                  ((arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : p * v) -
                    (Date.now() - e)) /
                  v
                );
              })(n, e.duration);
              if (r > 0) {
                var o = e.id,
                  a = (function () {
                    for (
                      var e =
                          arguments.length > 0 && void 0 !== arguments[0]
                            ? arguments[0]
                            : {},
                        t = arguments.length > 1 ? arguments[1] : void 0,
                        n = 0,
                        r = Object.keys(e).sort();
                      r.length;

                    ) {
                      var o = r.pop(),
                        a = e[o];
                      if (y <= n + a) return o;
                      n += a;
                    }
                    return t;
                  })(e.splits, t),
                  i = JSON.stringify({
                    testId: o,
                    segment: a,
                  });
                return w.create(b, i, r), a || t;
              }
            });
        }

        function k() {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return e.baseline ? e.baseline : "baseline";
        }
      },
      388: function (e, t) {
        var n, r, o;
        (r = []),
          (n = function () {
            function e(e) {
              if (!(e = e || {}).name || "string" != typeof e.name)
                throw new TypeError(
                  "config.name is required and must be string"
                );
              (this.name = e.name),
                (this.commonData = e.commonData || {}),
                this._verify(),
                this.q.push(["create", e]);
              for (
                var t, n, r = ["Staging", "Audience", "Anonymous"], o = 0;
                o < r.length;
                o++
              )
                ((n = e[(t = r[o]).toLowerCase()]) ||
                  e.hasOwnProperty(t.toLowerCase())) &&
                  this["set" + t](n);
              e.validationCallback &&
                this.enableValidation(e.validationCallback),
                !1 === e.timing && this.disableTiming(),
                e.brandDomain && this.setBrandDomain(e.brandDomain),
                e.eventClassFilter &&
                  this.setEventClassFilter(e.eventClassFilter);
            }
            return (
              (function () {
                function t() {
                  for (var e = n(arguments), t = 1; t < e.length; t++)
                    if (null !== e[t] && "object" == typeof e[t])
                      for (var r in e[t])
                        e[t].hasOwnProperty(r) && (e[0][r] = e[t][r]);
                  return e[0];
                }

                function n(e) {
                  return Array.prototype.slice.call(e);
                }

                function r(e, t, n) {
                  var r,
                    o,
                    a = t || 250;
                  return function () {
                    var t = n || this,
                      i = +new Date(),
                      s = arguments;
                    r && i < r + a
                      ? (clearTimeout(o),
                        (o = setTimeout(function () {
                          (r = i), e.apply(t, s);
                        }, a)))
                      : ((r = i), e.apply(t, s));
                  };
                }
                var o = [
                    "setClient",
                    "setDisplay",
                    "setAnonymous",
                    "setBrandDomain",
                    "setSource",
                    "setEnvironment",
                    "setAudience",
                    "setStaging",
                    "setEventClassFilter",
                    "setEU",
                  ],
                  a = {};

                function i(e) {
                  return function () {
                    this._verify();
                    var t = n(arguments);
                    t.unshift(e), t.push(this.name), this.q.push(t);
                  };
                }
                for (var s, c = 0; c < o.length; c++) a[(s = o[c])] = i(s);
                t(a, {
                  _verify: function () {
                    (window._bvaq = window._bvaq || []),
                      (this.q = window._bvaq);
                  },
                  _flushBatch: r(function () {
                    this._verify(), this.q.push(["flushBatch", this.name]);
                  }),
                  loadScript: function (e) {
                    var t = e || "latest",
                      n = document.createElement("script");
                    (n.type = "text/javascript"), (n.async = !0);
                    var r = "http:";
                    "https:" === window.location.protocol && (r = "https:");
                    var o = "analytics-static.ugc.bazaarvoice.com";
                    n.src =
                      r + "//" + o + "/prod/static/" + t + "/bv-analytics.js";
                    var a = document.getElementsByTagName("script")[0];
                    a.parentNode.insertBefore(n, a);
                  },
                  setCommonData: function (e) {
                    t(this.commonData, e);
                  },
                  configureSCIProvider: function (e, t) {
                    this._verify(),
                      this.q.push(["configureSCIProvider", e, t, this.name]);
                  },
                  enableValidation: function (e) {
                    this._verify(),
                      this.q.push(["enableValidation", e, this.name]);
                  },
                  disableValidation: function () {
                    this._verify(),
                      this.q.push(["disableValidation", this.name]);
                  },
                  enableTiming: function () {
                    this._verify(), this.q.push(["enableTiming", this.name]);
                  },
                  disableTiming: function () {
                    this._verify(), this.q.push(["disableTiming", this.name]);
                  },
                  addMeta: function (e, t) {
                    this._verify(), this.q.push(["addMeta", e, t, this.name]);
                  },
                  removeMeta: function (e) {
                    this._verify(), this.q.push(["removeMeta", e, this.name]);
                  },
                  trackEvent: function (e, n) {
                    this._verify(),
                      this.q.push([
                        "addBatchItem",
                        e,
                        t({}, this.commonData, n),
                        this.name,
                      ]),
                      this._flushBatch();
                  },
                  trackPageView: function (e) {
                    this._verify(),
                      this.q.push([
                        "trackPageView",
                        t({}, this.commonData, e),
                        this.name,
                      ]);
                  },
                  trackError: function (e) {
                    this._verify(),
                      this.q.push([
                        "trackEvent",
                        "Error",
                        t({}, this.commonData, e),
                        this.name,
                      ]);
                  },
                  trackConversion: function (e) {
                    this._verify(),
                      this.q.push([
                        "trackConversion",
                        t({}, this.commonData, e),
                        this.name,
                      ]);
                  },
                  trackTransaction: function (e) {
                    this._verify(),
                      this.q.push([
                        "trackTransaction",
                        t({}, this.commonData, e),
                        this.name,
                      ]);
                  },
                  trackImpression: function (e) {
                    this._verify(),
                      this.trackEvent(
                        "Impression",
                        t({}, this.commonData, e),
                        this.name
                      );
                  },
                  doNotTrack: function (e) {
                    this._verify(), this.q.push(["doNotTrack", e, this.name]);
                  },
                }),
                  t(e.prototype, a),
                  (function () {
                    var n,
                      r = [],
                      o = 0,
                      a = 250;

                    function i(e, n) {
                      if (
                        !(e = t(
                          {
                            minPixels: 100,
                            minTime: 5e3,
                          },
                          e
                        )).containerId
                      )
                        throw new Error("No containerId specified.");
                      e.observerId = o++;
                      var a = function (t) {
                        c(e.observerId), n(t);
                      };
                      return (e.callback = a), r.push(e), s(), e.observerId;
                    }

                    function s() {
                      var e = "number" == typeof n;
                      r.length >= 1 && !e
                        ? (n = setInterval(d, a))
                        : 0 === r.length && e && (clearInterval(n), (n = null));
                    }

                    function c(e) {
                      for (var t = 0; t < r.length; t++)
                        r[t].observerId === e && (r.splice(t, 1), s());
                    }

                    function u() {
                      var e =
                        window.document && window.document.documentElement;
                      return {
                        height: window.innerHeight || e.clientHeight,
                        width: window.innerWidth || e.clientWidth,
                      };
                    }

                    function l(e) {
                      var t,
                        n = e.getBoundingClientRect(),
                        r = u().height;
                      return n.top <= 0
                        ? ((t = Math.max(n.top + n.height, 0)),
                          (t = Math.min(t, r)))
                        : n.top >= r
                        ? 0
                        : Math.min(r - n.top, n.height);
                    }

                    function f(e) {
                      var t,
                        n = e.getBoundingClientRect(),
                        r = u().width;
                      return n.left <= 0
                        ? ((t = Math.max(n.left + n.width, 0)),
                          (t = Math.min(t, r)))
                        : n.left >= r
                        ? 0
                        : Math.min(r - n.left, n.width);
                    }

                    function d() {
                      for (var e, t, n, o = 0; o < r.length; o++)
                        (n = r[o]),
                          (e = document.getElementById(n.containerId)),
                          (t = +new Date()),
                          e
                            ? f(e) <= 0 || l(e) < n.minPixels
                              ? delete n.inViewAt
                              : n.inViewAt
                              ? t - n.inViewAt > n.minTime && n.callback()
                              : ((n.inViewAt = t),
                                0 === n.minTime && n.callback())
                            : delete n.inViewAt;
                    }

                    function m(e) {
                      this.id = e;
                    }
                    (m.prototype.remove = function () {
                      c(this.id);
                    }),
                      (e.prototype.trackEventWhenVisible = function (e, n) {
                        var r = this;
                        if (!e || "string" != typeof e.cl)
                          throw new TypeError(
                            "data.cl must exist and be a string"
                          );
                        return new m(
                          i(n, function () {
                            var n = t({}, r.commonData, e);
                            r.trackEvent(n.cl, n);
                          })
                        );
                      }),
                      (e.prototype.trackInView = function (e, n) {
                        var r = this;
                        return new m(
                          i(
                            (n = t({}, n, {
                              minTime: 0,
                            })),
                            function () {
                              var n = t({}, r.commonData, e, {
                                name: "InView",
                                type: "Used",
                                interaction: "0",
                              });
                              r.trackEvent("Feature", n);
                            }
                          )
                        );
                      }),
                      (e.prototype.trackViewedCGC = function (e, n) {
                        var r = this;
                        return new m(
                          i(n, function () {
                            var n = t({}, r.commonData, e, {
                              name: "ViewedUGC",
                              type: "Used",
                              interaction: "1",
                            });
                            r.trackEvent("Feature", n);
                          })
                        );
                      });
                  })();
              })(),
              e
            );
          }),
          void 0 === (o = "function" == typeof n ? n.apply(t, r) : n) ||
            (e.exports = o);
      },
      424: (e, t, n) => {
        var r = n(920);

        function o(e, t, n) {
          if ("function" != typeof t)
            throw new Error("A function must be provided to process the queue");
          var r = e.length;

          function o() {
            var r = e.shift();
            n
              ? t(r)
              : setTimeout(function () {
                  t(r);
                }, 0);
          }
          for (; e.length > 0; ) o();
          return r;
        }

        function a(e) {
          return (
            (this.config = e),
            (this._readyQueue = []),
            (this._renderQueue = []),
            (this._configQueue = []),
            (this._promise = new r(
              function (e, t) {
                (this._resolve = e), (this._reject = t);
              }.bind(this)
            )),
            this
          );
        }
        (a.prototype.ready = function (e) {
          return (
            "function" == typeof e && this._readyQueue.push(e), this._promise
          );
        }),
          (a.prototype.render = function (e) {
            return this._renderQueue.push(e);
          }),
          (a.prototype.configure = function (e) {
            return this._configQueue.push(e);
          });
        var i = function (e, t) {
          "function" == typeof t && t(e, this);
        };
        (a.prototype.processReady = function (e) {
          var t = i.bind(this, e);
          o.call(this, this._readyQueue, t, !0),
            (this._readyQueue.push = t),
            (this.ready = function (e) {
              return t(e), this._promise;
            }),
            e ? this._reject(e) : this._resolve(this);
        }),
          (a.prototype.processQueue = function (e) {
            o.call(this, this._renderQueue, e),
              (this.render = this._renderQueue.push = e);
          }),
          (a.prototype.processConfig = function (e) {
            o.call(this, this._configQueue, e, !0),
              (this.configure = this._configQueue.push = e);
          }),
          (e.exports = a);
      },
      974: (e, t, n) => {
        var r = n(422),
          o = n(795),
          a = {};

        function i(e, t, n, o, a) {
          var i = new Date();
          i.setTime(i.getTime() + 24 * n * 60 * 60 * 1e3);
          var s = n ? ";expires=" + i.toGMTString() : "",
            c =
              encodeURIComponent(e) +
              "=" +
              encodeURIComponent(t) +
              s +
              ";path=/" +
              (o ? ";domain=" + o : "") +
              (a ? ";secure" : "");
          r.document.cookie = c;
        }

        function s(e, t) {
          delete a[e], t ? i(e, null, -1, t) : i(e, "", -1);
        }
        e.exports = {
          create: function (e, t, n, r, c) {
            (a[e] = t),
              o.getConsent(e) && i(e, t, n, r, c),
              o.subscribe(e, "add", function (o) {
                o ? i(e, t, n, r, c) : s(e, r);
              }),
              o.subscribe(e, "enable", function () {
                i(e, t, n, r, c);
              }),
              o.subscribe(e, "disable", function () {
                s(e, r);
              });
          },
          read: function (e) {
            var t,
              n = encodeURIComponent(e) + "=",
              o = r.document.cookie.split(";");
            for (t = 0; t < o.length; t++) {
              for (var a = o[t]; " " === a.charAt(0); )
                a = a.substring(1, a.length);
              if (0 === a.indexOf(n))
                return decodeURIComponent(a.substring(n.length, a.length));
            }
            return null;
          },
          remove: s,
        };
      },
      795: (e) => {
        var t = (function () {
          var e = !1,
            t = !0,
            n = {},
            r = {},
            o = ["add", "enable", "disable", "change"],
            a = {};

          function i(e, t, n) {
            r[e] &&
              r[e][t] &&
              Object.values(r[e][t]).forEach(function (e) {
                e(n);
              });
          }

          function s() {
            Object.values(a).length > 0 &&
              Object.values(a).forEach(function (e) {
                e(Object.assign({}, n));
              });
          }

          function c(e, t) {
            if ("boolean" != typeof t)
              throw new TypeError(
                "cookieConsent (setConsent): consent values should be of type boolean. Check value for " +
                  e +
                  "."
              );
            var r = n[e];
            r !== t &&
              ((n[e] = t),
              void 0 === r && i(e, "add", t),
              !0 === r
                ? (i(e, "disable", t), i(e, "change", t))
                : !1 === r
                ? (i(e, "enable", t), i(e, "change", t))
                : i(e, "change", t));
          }

          function u() {
            r[this.consentKey] &&
              r[this.consentKey][this.eventName] &&
              delete r[this.consentKey][this.eventName][this.key];
          }

          function l() {
            a[this.key] && delete a[this.key];
          }
          return {
            initConsent: function (r, o) {
              if (!e) {
                if ((t = !!o)) return (e = !0), !0;
                if (!r || Array.isArray(r) || "object" != typeof r)
                  throw new TypeError(
                    "cookieConsent (init): consent should be an object."
                  );
                for (var a = Object.keys(r), i = 0; i < a.length; i++)
                  if ("boolean" != typeof r[a[i]])
                    throw new TypeError(
                      "cookieConsent (init): consent values for " +
                        a[i] +
                        " should be of type boolean."
                    );
                return (n = Object.assign({}, r)), (e = !0), !0;
              }
              return !1;
            },
            getConsent: function (e) {
              return !!t || n[e];
            },
            getConsentDisabled: function () {
              return t;
            },
            setConsent: function (n) {
              if (e && !t) {
                if (!n || Array.isArray(n) || "object" != typeof n)
                  throw new TypeError(
                    "cookieConsent (setConsent): consent should be an object."
                  );
                for (var r, o = Object.keys(n), a = 0; a < o.length; a++)
                  c(o[a], n[o[a]]);
                var i = Object.assign({}, r);
                return JSON.stringify(i) !== JSON.stringify(r) && s(), !0;
              }
              return !1;
            },
            subscribe: function (e, t, n) {
              if ("string" != typeof e)
                throw new TypeError(
                  "cookieConsent (subscribe): consent key should be of type string."
                );
              if ("string" != typeof t)
                throw new TypeError(
                  "cookieConsent (subscribe): event name should be of type string."
                );
              if (!o.includes(t))
                throw new TypeError(
                  "cookieConsent (subscribe): event name should be one of " +
                    o.join(", ") +
                    "."
                );
              if ("function" != typeof n)
                throw new TypeError(
                  "cookieConsent (subscribe): callback should be a function."
                );
              r[e] || (r[e] = {}), r[e][t] || (r[e][t] = {});
              var a = Math.random().toString(36).substr(2, 5);
              return (
                (r[e][t][a] = n),
                {
                  unsubscribe: u.bind({
                    consentKey: e,
                    eventName: t,
                    key: a,
                  }),
                }
              );
            },
            subscribeToConsentStore: function (e) {
              if ("function" != typeof e)
                throw new TypeError(
                  "cookieConsent (subscribeToConsentStore): callback should be a function."
                );
              var t = Math.random().toString(36).substr(2, 5);
              return (
                (a[t] = e),
                {
                  unsubscribe: l.bind({
                    key: t,
                  }),
                }
              );
            },
          };
        })();
        e.exports = t;
      },
      411: (e, t, n) => {
        var r = n(422).Date,
          o = r && r.now,
          a = "function" == typeof o;

        function i() {
          return o.call(r);
        }

        function s() {
          return new r().getTime();
        }
        e.exports = {
          now: function () {
            return (a ? i : s)();
          },
        };
      },
      611: (e) => {
        function t(e, t) {
          if (e && "." === e.charAt(0) && t) {
            var n = ("." + t).lastIndexOf(e);
            return n >= 0 && n === 1 + t.length - e.length;
          }
          return t === e || t === "www." + e;
        }
        e.exports = function (e, n) {
          var r = {},
            o = {
              isValid: !1,
              get: function (e) {
                return r[e];
              },
            },
            a = (function (e, n) {
              for (var r = 0; r < e.length; r++)
                if (t(e[r].domain, n)) return e[r];
            })(e, n);
          if (a) {
            for (var i in ((o.isValid = !0), a))
              a.hasOwnProperty(i) && (r[i] = a[i]);
            r.domain.match(/^(\.\d+){4}$/) && (r.domain = r.domain.substr(1));
          }
          return o;
        };
      },
      5: (e, t, n) => {
        var r = Array.prototype,
          o = r.indexOf,
          a = r.slice;

        function i(e) {
          n.g.console.error(e);
        }

        function s(e) {
          this.eventErrorHandler = e;
        }

        function c(e, t) {
          var n,
            r,
            o = (this.events = this.events || {}),
            a = e.split(/\s+/),
            i = a.length;
          for (n = 0; n < i; n++) (o[(r = a[n])] = o[r] || []), o[r].push(t);
          return this;
        }

        function u(e, t) {
          var n = function () {
            this.off(e, n), t.apply(this, a.call(arguments));
          };
          return this.on(e, n), this;
        }

        function l(e, t) {
          var n,
            r,
            o,
            a,
            i,
            s = this.events;
          if (s) {
            for (r = 0, a = (i = e.split(/\s+/)).length; r < a; r++)
              (n = i[r]) in s != !1 &&
                -1 !== (o = t ? d(s[n], t) : 0) &&
                s[n].splice(o, 1);
            return this;
          }
        }

        function f(e) {
          var t,
            n,
            r = this.events;
          if (r && e in r != !1) {
            for (t = a.call(arguments, 1), n = r[e].length - 1; n >= 0; n--)
              try {
                r[e][n].apply(this, t);
              } catch (n) {
                (this.eventErrorHandler || i).call(this, n, {
                  event: e,
                  data: t,
                });
              }
            return this;
          }
        }

        function d(e, t) {
          var n, r;
          if (o && e.indexOf === o) return e.indexOf(t);
          for (n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
          return -1;
        }
        e.exports = function () {
          return (
            (this.on = c),
            (this.off = l),
            (this.trigger = this.emit = f),
            (this.one = this.once = u),
            (this.setErrorHandler = s),
            this
          );
        };
      },
      423: (e, t, n) => {
        var r,
          o = n(920),
          a = n(10),
          i = {},
          s = /function\s+([^\(\s]+)/;
        e.exports = function (e) {
          return new o(function (t) {
            a(function () {
              var n = e.name;
              n || (n = s.exec(e.toString())[1]),
                r ||
                  (((r = document.createElement("iframe")).src = "about:blank"),
                  (r.style.display = "none"),
                  (r.height = "0"),
                  (r.width = "0"),
                  (r.tabIndex = "-1"),
                  (r.title = "empty"),
                  (r.className = "hidden"),
                  document.body.appendChild(r)),
                i[n] || (i[n] = r.contentWindow[n]),
                t(i[n]);
            });
          });
        };
      },
      422: (e, t, n) => {
        "use strict";
        e.exports = (function () {
          var e = (function () {
            if ("undefined" != typeof globalThis) return globalThis;
            if ("undefined" != typeof window) return window;
            if ("undefined" != typeof self) return self;
            if (void 0 !== n.g) return n.g;
            throw new Error("unable to locate global object");
          })();
          if (e && e.__esModule) {
            return new Proxy(e, {
              get: function (e, t) {
                return "default" === t ? e : e[t];
              },
              set: function (e, t, n) {
                return (e[t] = n), !0;
              },
            });
          }
          return e;
        })();
      },
      788: (e, t, n) => {
        var r = n(422),
          o = n(530),
          a = r.document,
          i = {};

        function s() {
          return a.getElementsByTagName("script")[0];
        }

        function c(e) {
          return (
            !e || "loaded" === e || "complete" === e || "uninitialized" === e
          );
        }

        function u(e, t, n) {
          if (!e || "string" != typeof e)
            throw new Error("`url` must be a string");
          if (t.namespaceName && "string" != typeof t.namespaceName)
            throw new Error("`options.namespaceName` must be a string");
          if (t.forceLoad && "boolean" != typeof t.forceLoad)
            throw new Error("`options.forceLoad` must be a boolean");
          if ("number" != typeof t.timeout)
            throw new Error("`options.timeout` must be a number");
          if (n && "function" != typeof n)
            throw new Error("`callback` must be a function");
        }
        e.exports = {
          _clearLoadedUrls: function (e) {
            e ? (o.namespace(e).loadedUrls = {}) : (i = {});
          },
          loadScript: function (e, t, n) {
            var r,
              l = i;
            if (
              ("function" == typeof t && ((n = t), (t = null)),
              ((t = t || {}).timeout = t.timeout || 1e4),
              u(e, t, n),
              t.namespaceName &&
                ((r = o.namespace(t.namespaceName)), (l = r.loadedUrls || {})),
              t.forceLoad || !l[e])
            ) {
              var f,
                d = a.createElement("script"),
                m = !1;
              if (t.attributes)
                for (f in t.attributes) d.setAttribute(f, t.attributes[f]);
              (d.onreadystatechange = d.onload =
                function () {
                  !m && c(d.readyState) && v();
                }),
                (d.onerror = function () {
                  m || v(new Error("Error: could not load " + e));
                });
              var p = setTimeout(function () {
                m || v(new Error("Error: script timeout " + e));
              }, t.timeout);
              setTimeout(function () {
                d.src = e;
                var t = s();
                t.parentNode.insertBefore(d, t);
              }, 0);
            } else "function" == typeof n && n();

            function v(o) {
              (m = !0),
                clearTimeout(p),
                (d.onload = d.onreadystatechange = d.onerror = null),
                d.parentNode.removeChild(d),
                o ||
                  ((l[e] = !0), t.namespaceName ? (r.loadedUrls = l) : (i = l)),
                "function" == typeof n && n(o);
            }
          },
          loadStyleSheet: function (e, t, n) {
            var l,
              f = i;
            if (
              ("function" == typeof t && ((n = t), (t = null)),
              ((t = t || {}).timeout = t.timeout || 1e4),
              u(e, t, n),
              "injectionNode" in t && !(t.injectionNode instanceof r.Element))
            )
              throw new Error("`options.injectionNode` must be a DOM node");
            if (
              (t.namespaceName &&
                ((l = o.namespace(t.namespaceName)), (f = l.loadedUrls || {})),
              t.forceLoad || !f[e])
            ) {
              var d,
                m = a.createElement("link"),
                p = !1;
              if (t.attributes)
                for (d in t.attributes) m.setAttribute(d, t.attributes[d]);
              (m.onreadystatechange = m.onload =
                function () {
                  !p && c(m.readyState) && h();
                }),
                (m.onerror = function () {
                  p || h(new Error("Error: could not load " + e));
                });
              var v = setTimeout(m.onerror, t.timeout);
              setTimeout(function () {
                (m.media = "only x"),
                  (m.rel = "stylesheet"),
                  (m.type = "text/css"),
                  (m.href = e),
                  setTimeout(function () {
                    m.media = "all";
                  }, 0);
                var n = t.injectionNode || s().parentNode;
                try {
                  n.appendChild(m);
                } catch (e) {
                  h(new Error("Error: could not append LINK element"));
                }
              }, 0);
            } else "function" == typeof n && n();

            function h(r) {
              (p = !0),
                clearTimeout(v),
                (m.onload = m.onreadystatechange = m.onerror = null),
                r ||
                  ((f[e] = !0), t.namespaceName ? (l.loadedUrls = f) : (i = f)),
                "function" == typeof n && n(r);
            }
          },
        };
      },
      530: (e, t, n) => {
        var r = n(422);

        function o(e) {
          this.name = e;
        }
        (o.prototype.registerProperty = function (e, t) {
          if (this.hasOwnProperty(e))
            throw new Error(
              "Cannot register " +
                e +
                " because a property with that name already exists on window." +
                this.name
            );
          return (this[e] = t), this;
        }),
          (e.exports = {
            namespace: function (e) {
              if (void 0 === r[e])
                Object.defineProperty(r, e, {
                  value: new o(e),
                });
              else {
                if ("object" != typeof r[e])
                  throw new Error(
                    "Namespace " +
                      e +
                      " cannot be created. A non-object variable is already assigned to window." +
                      e
                  );
                if (!(r[e] instanceof o))
                  for (var t in (o.call(r[e], e), o.prototype))
                    r[e][t] = o.prototype[t];
              }
              return r[e];
            },
          });
      },
      921: (e) => {
        e.exports = {
          timeline: [],
        };
      },
      453: (e, t, n) => {
        var r = n(422),
          o = n(921).timeline,
          a = r.performance,
          i = a && a.getEntries,
          s = "function" == typeof i;

        function c() {
          return i.call(a);
        }

        function u() {
          return o;
        }
        e.exports = {
          getEntries: function () {
            return (s ? c : u)();
          },
        };
      },
      966: (e, t, n) => {
        var r = n(422),
          o = n(453).getEntries,
          a = r.performance,
          i = a && a.getEntriesByName,
          s = "function" == typeof i;

        function c(e, t) {
          return i.call(a, e, t);
        }

        function u(e, t) {
          if (0 === arguments.length)
            throw new TypeError(
              "Failed to execute 'getEntriesByName' on 'Performance': 1 argument required, but only 0 present."
            );
          return o().filter(function (n) {
            if (n.name === e && (void 0 === t || n.entryType === t)) return n;
          });
        }
        e.exports = {
          getEntriesByName: function (e, t) {
            var n = s ? c : u;
            return arguments.length > 0 ? n(e, t) : n();
          },
        };
      },
      105: (e, t, n) => {
        var r = n(422),
          o = n(453).getEntries,
          a = r.performance,
          i = a && a.getEntriesByType,
          s = "function" == typeof i;

        function c(e) {
          return i.call(a, e);
        }

        function u(e) {
          if (0 === arguments.length)
            throw new TypeError(
              "Failed to execute 'getEntriesByType' on 'Performance': 1 argument required, but only 0 present."
            );
          return o().filter(function (t) {
            return t.entryType === e;
          });
        }
        e.exports = {
          getEntriesByType: function (e) {
            var t = s ? c : u;
            return arguments.length > 0 ? t(e) : t();
          },
        };
      },
      916: (e, t, n) => {
        (e.exports.getEntries = n(453).getEntries),
          (e.exports.getEntriesByName = n(966).getEntriesByName),
          (e.exports.getEntriesByType = n(105).getEntriesByType),
          (e.exports.now = n(755).now),
          (e.exports.mark = n(202).mark),
          (e.exports.measure = n(165).measure);
      },
      202: (e, t, n) => {
        var r = n(422),
          o = n(755),
          a = n(921).timeline,
          i = r.performance,
          s = i && i.mark,
          c = "function" == typeof s,
          u = {
            navigationStart: 1,
            unloadEventStart: 1,
            unloadEventEnd: 1,
            redirectStart: 1,
            redirectEnd: 1,
            fetchStart: 1,
            domainLookupStart: 1,
            domainLookupEnd: 1,
            connectStart: 1,
            connectEnd: 1,
            secureConnectionStart: 1,
            requestStart: 1,
            responseStart: 1,
            responseEnd: 1,
            domLoading: 1,
            domInteractive: 1,
            domContentLoadedEventStart: 1,
            domContentLoadedEventEnd: 1,
            domComplete: 1,
            loadEventStart: 1,
            loadEventEnd: 1,
          };

        function l(e) {
          return s.call(i, e);
        }

        function f(e) {
          if (arguments.length < 1)
            throw new SyntaxError("Cannot set mark without a name");
          if (e in u)
            throw new SyntaxError(
              'Cannot set mark with reserved name "' + e + '"'
            );
          var t = {
            entryType: "mark",
            name: e,
            startTime: o.now(),
            duration: 0,
          };
          a.push(t);
        }
        e.exports = {
          mark: function (e) {
            var t = c ? l : f;
            return arguments.length > 0 ? t(e) : t();
          },
        };
      },
      165: (e, t, n) => {
        var r = n(422),
          o = n(755).now,
          a = n(105).getEntriesByType,
          i = n(921).timeline,
          s = r.performance,
          c = s && s.measure,
          u = "function" == typeof c;

        function l(e, t, n) {
          return void 0 === t
            ? c.call(s, e)
            : void 0 === n
            ? c.call(s, e, t)
            : c.call(s, e, t, n);
        }

        function f(e, t, n) {
          if (arguments.length < 1)
            throw new TypeError(
              "Failed to execute 'measure' on 'Performance': 1 argument required, but only 0 present."
            );
          var r,
            s = a("mark"),
            c = 0,
            u = o();
          if (void 0 !== t) {
            if (
              !(r = s.filter(function (e) {
                return e.entryName === t;
              })).length
            )
              throw new Error(
                "Failed to execute 'measure' on 'Performance': The mark '" +
                  t +
                  "' does not exist."
              );
            c = r[r.length - 1].startTime;
          }
          if (void 0 !== n) {
            if (
              !(r = s.filter(function (e) {
                return e.entryName === n;
              })).length
            )
              throw new Error(
                "Failed to execute 'measure' on 'Performance': The mark '" +
                  n +
                  "' does not exist."
              );
            u = r[r.length - 1].startTime;
          }
          var l = {
            entryType: "measure",
            name: e,
            startTime: c,
            duration: u - c,
          };
          i.push(l);
        }
        e.exports = {
          measure: function (e, t, n) {
            var r = u ? l : f;
            return arguments.length > 0 ? r(e, t, n) : r();
          },
        };
      },
      755: (e, t, n) => {
        var r = n(422),
          o = n(411),
          a = r.performance,
          i = a && a.now,
          s = "function" == typeof i,
          c = o.now();

        function u() {
          return i.call(a);
        }

        function l() {
          return o.now() - c;
        }
        a &&
          a.timing &&
          "number" == typeof a.timing.navigationStart &&
          (c = a.timing.navigationStart),
          (e.exports = {
            now: function () {
              return (s ? u : l)();
            },
          });
      },
      920: (e, t, n) => {
        var r = n(422);
        if (
          void 0 !== r.Promise &&
          r.Promise.toString().match(/\[native code]/)
        )
          e.exports = r.Promise;
        else {
          var o = setTimeout;

          function a() {}

          function i(e) {
            if ("object" != typeof this)
              throw new TypeError("Promises must be constructed via new");
            if ("function" != typeof e) throw new TypeError("not a function");
            (this._state = 0),
              (this._handled = !1),
              (this._value = void 0),
              (this._deferreds = []),
              d(e, this);
          }

          function s(e, t) {
            for (; 3 === e._state; ) e = e._value;
            0 !== e._state
              ? ((e._handled = !0),
                i._immediateFn(function () {
                  var n = 1 === e._state ? t.onFulfilled : t.onRejected;
                  if (null !== n) {
                    var r;
                    try {
                      r = n(e._value);
                    } catch (e) {
                      return void u(t.promise, e);
                    }
                    c(t.promise, r);
                  } else (1 === e._state ? c : u)(t.promise, e._value);
                }))
              : e._deferreds.push(t);
          }

          function c(e, t) {
            try {
              if (t === e)
                throw new TypeError(
                  "A promise cannot be resolved with itself."
                );
              if (t && ("object" == typeof t || "function" == typeof t)) {
                var n = t.then;
                if (t instanceof i)
                  return (e._state = 3), (e._value = t), void l(e);
                if ("function" == typeof n)
                  return void d(
                    ((r = n),
                    (o = t),
                    function () {
                      r.apply(o, arguments);
                    }),
                    e
                  );
              }
              (e._state = 1), (e._value = t), l(e);
            } catch (t) {
              u(e, t);
            }
            var r, o;
          }

          function u(e, t) {
            (e._state = 2), (e._value = t), l(e);
          }

          function l(e) {
            2 === e._state &&
              0 === e._deferreds.length &&
              i._immediateFn(function () {
                e._handled || i._unhandledRejectionFn(e._value);
              });
            for (var t = 0, n = e._deferreds.length; t < n; t++)
              s(e, e._deferreds[t]);
            e._deferreds = null;
          }

          function f(e, t, n) {
            (this.onFulfilled = "function" == typeof e ? e : null),
              (this.onRejected = "function" == typeof t ? t : null),
              (this.promise = n);
          }

          function d(e, t) {
            var n = !1;
            try {
              e(
                function (e) {
                  n || ((n = !0), c(t, e));
                },
                function (e) {
                  n || ((n = !0), u(t, e));
                }
              );
            } catch (e) {
              if (n) return;
              (n = !0), u(t, e);
            }
          }
          (i.prototype.catch = function (e) {
            return this.then(null, e);
          }),
            (i.prototype.then = function (e, t) {
              var n = new this.constructor(a);
              return s(this, new f(e, t, n)), n;
            }),
            (i.all = function (e) {
              var t = Array.prototype.slice.call(e);
              return new i(function (e, n) {
                if (0 === t.length) return e([]);
                var r = t.length;

                function o(a, i) {
                  try {
                    if (i && ("object" == typeof i || "function" == typeof i)) {
                      var s = i.then;
                      if ("function" == typeof s)
                        return void s.call(
                          i,
                          function (e) {
                            o(a, e);
                          },
                          n
                        );
                    }
                    (t[a] = i), 0 == --r && e(t);
                  } catch (e) {
                    n(e);
                  }
                }
                for (var a = 0; a < t.length; a++) o(a, t[a]);
              });
            }),
            (i.resolve = function (e) {
              return e && "object" == typeof e && e.constructor === i
                ? e
                : new i(function (t) {
                    t(e);
                  });
            }),
            (i.reject = function (e) {
              return new i(function (t, n) {
                n(e);
              });
            }),
            (i.race = function (e) {
              return new i(function (t, n) {
                for (var r = 0, o = e.length; r < o; r++) e[r].then(t, n);
              });
            }),
            (i._immediateFn =
              ("function" == typeof setImmediate &&
                function (e) {
                  setImmediate(e);
                }) ||
              function (e) {
                o(e, 0);
              }),
            (i._unhandledRejectionFn = function (e) {
              "undefined" != typeof console &&
                console &&
                console.warn("Possible Unhandled Promise Rejection:", e);
            }),
            (e.exports = i);
        }
      },
      581: (e) => {
        function t(e) {
          return e && e.shadowRoot
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_SKIP;
        }

        function n(e) {
          if (!e) return;
          const r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, t);
          let o = [];
          for (
            e.shadowRoot && (o.push(e), (o = o.concat(n(e.shadowRoot))));
            r.nextNode();

          )
            o.push(r.currentNode),
              r.currentNode.shadowRoot &&
                (o = o.concat(n(r.currentNode.shadowRoot)));
          return o;
        }

        function r(e, t) {
          if (e && e.shadowRoot && t) return e.shadowRoot.querySelectorAll(t);
        }
        e.exports = {
          findShadowRoots: n,
          filterShadowHosts: t,
          shadowQuerySelectorAll: function (e, t) {
            if (!e || !t) throw new Error(`Unable to find ${e} or ${t}`);
            const o = e.querySelectorAll(t),
              a = n(e);
            let i = [];
            for (const e of a) {
              const n = r(e, t);
              n.length > 0 && i.push(...n);
            }
            return [...o, ...i];
          },
          findElementsInShadowDomByMatchSector: r,
        };
      },
      10: (e) => {
        function t(e, t) {
          document.body && (t.disconnect(), e());
        }
        e.exports = function (e) {
          if (document.body) e();
          else {
            var n = new MutationObserver(function () {
              t(e, n);
            });
            n.observe(document.documentElement, {
              childList: !0,
              subtree: !0,
            }),
              t(e, n);
          }
        };
      },
      390: function (e, t) {
        "use strict";
        var n =
          (this && this.__spreadArrays) ||
          function () {
            for (var e = 0, t = 0, n = arguments.length; t < n; t++)
              e += arguments[t].length;
            var r = Array(e),
              o = 0;
            for (t = 0; t < n; t++)
              for (var a = arguments[t], i = 0, s = a.length; i < s; i++, o++)
                r[o] = a[i];
            return r;
          };
        Object.defineProperty(t, "__esModule", {
          value: !0,
        });
        var r = function (e, t, n) {
          (this.name = e), (this.version = t), (this.os = n);
        };
        t.BrowserInfo = r;
        var o = function (e) {
          (this.version = e),
            (this.name = "node"),
            (this.os = process.platform);
        };
        t.NodeInfo = o;
        var a = function () {
          (this.bot = !0),
            (this.name = "bot"),
            (this.version = null),
            (this.os = null);
        };
        t.BotInfo = a;
        var i = 3,
          s = [
            ["aol", /AOLShield\/([0-9\._]+)/],
            ["edge", /Edge\/([0-9\._]+)/],
            ["edge-ios", /EdgiOS\/([0-9\._]+)/],
            ["yandexbrowser", /YaBrowser\/([0-9\._]+)/],
            ["vivaldi", /Vivaldi\/([0-9\.]+)/],
            ["kakaotalk", /KAKAOTALK\s([0-9\.]+)/],
            ["samsung", /SamsungBrowser\/([0-9\.]+)/],
            ["silk", /\bSilk\/([0-9._-]+)\b/],
            ["miui", /MiuiBrowser\/([0-9\.]+)$/],
            ["beaker", /BeakerBrowser\/([0-9\.]+)/],
            ["edge-chromium", /Edg\/([0-9\.]+)/],
            [
              "chromium-webview",
              /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
            ],
            ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
            ["phantomjs", /PhantomJS\/([0-9\.]+)(:?\s|$)/],
            ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/],
            ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/],
            ["fxios", /FxiOS\/([0-9\.]+)/],
            ["opera-mini", /Opera Mini.*Version\/([0-9\.]+)/],
            ["opera", /Opera\/([0-9\.]+)(?:\s|$)/],
            ["opera", /OPR\/([0-9\.]+)(:?\s|$)/],
            ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
            ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
            ["ie", /MSIE\s(7\.0)/],
            ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/],
            ["android", /Android\s([0-9\.]+)/],
            ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/],
            ["safari", /Version\/([0-9\._]+).*Safari/],
            ["facebook", /FBAV\/([0-9\.]+)/],
            ["instagram", /Instagram\s([0-9\.]+)/],
            ["ios-webview", /AppleWebKit\/([0-9\.]+).*Mobile/],
            ["ios-webview", /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
            [
              "searchbot",
              /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/,
            ],
          ],
          c = [
            ["iOS", /iP(hone|od|ad)/],
            ["Android OS", /Android/],
            ["BlackBerry OS", /BlackBerry|BB10/],
            ["Windows Mobile", /IEMobile/],
            ["Amazon OS", /Kindle/],
            ["Windows 3.11", /Win16/],
            ["Windows 95", /(Windows 95)|(Win95)|(Windows_95)/],
            ["Windows 98", /(Windows 98)|(Win98)/],
            ["Windows 2000", /(Windows NT 5.0)|(Windows 2000)/],
            ["Windows XP", /(Windows NT 5.1)|(Windows XP)/],
            ["Windows Server 2003", /(Windows NT 5.2)/],
            ["Windows Vista", /(Windows NT 6.0)/],
            ["Windows 7", /(Windows NT 6.1)/],
            ["Windows 8", /(Windows NT 6.2)/],
            ["Windows 8.1", /(Windows NT 6.3)/],
            ["Windows 10", /(Windows NT 10.0)/],
            ["Windows ME", /Windows ME/],
            ["Open BSD", /OpenBSD/],
            ["Sun OS", /SunOS/],
            ["Chrome OS", /CrOS/],
            ["Linux", /(Linux)|(X11)/],
            ["Mac OS", /(Mac_PowerPC)|(Macintosh)/],
            ["QNX", /QNX/],
            ["BeOS", /BeOS/],
            ["OS/2", /OS\/2/],
            [
              "Search Bot",
              /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/,
            ],
          ];

        function u(e) {
          var t =
            "" !== e &&
            s.reduce(function (t, n) {
              var r = n[0],
                o = n[1];
              if (t) return t;
              var a = o.exec(e);
              return !!a && [r, a];
            }, !1);
          if (!t) return null;
          var o = t[0],
            c = t[1];
          if ("searchbot" === o) return new a();
          var u = c[1] && c[1].split(/[._]/).slice(0, 3);
          return (
            u
              ? u.length < i &&
                (u = n(
                  u,
                  (function (e) {
                    for (var t = [], n = 0; n < e; n++) t.push("0");
                    return t;
                  })(i - u.length)
                ))
              : (u = []),
            new r(o, u.join("."), l(e))
          );
        }

        function l(e) {
          for (var t = 0, n = c.length; t < n; t++) {
            var r = c[t],
              o = r[0];
            if (r[1].test(e)) return o;
          }
          return null;
        }

        function f() {
          return "undefined" != typeof process && process.version
            ? new o(process.version.slice(1))
            : null;
        }
        (t.detect = function (e) {
          return e
            ? u(e)
            : "undefined" != typeof navigator
            ? u(navigator.userAgent)
            : f();
        }),
          (t.parseUserAgent = u),
          (t.detectOS = l),
          (t.getNodeVersion = f);
      },
      753: function (e, t, n) {
        var r, o, a;
        !(function (i, s) {
          "use strict";
          (o = [n(508)]),
            void 0 ===
              (a =
                "function" ==
                typeof (r = function (e) {
                  var t = /(^|@)\S+:\d+/,
                    n = /^\s*at .*(\S+:\d+|\(native\))/m,
                    r = /^(eval@)?(\[native code])?$/;
                  return {
                    parse: function (e) {
                      if (
                        void 0 !== e.stacktrace ||
                        void 0 !== e["opera#sourceloc"]
                      )
                        return this.parseOpera(e);
                      if (e.stack && e.stack.match(n))
                        return this.parseV8OrIE(e);
                      if (e.stack) return this.parseFFOrSafari(e);
                      throw new Error("Cannot parse given Error object");
                    },
                    extractLocation: function (e) {
                      if (-1 === e.indexOf(":")) return [e];
                      var t = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(
                        e.replace(/[()]/g, "")
                      );
                      return [t[1], t[2] || void 0, t[3] || void 0];
                    },
                    parseV8OrIE: function (t) {
                      return t.stack
                        .split("\n")
                        .filter(function (e) {
                          return !!e.match(n);
                        }, this)
                        .map(function (t) {
                          t.indexOf("(eval ") > -1 &&
                            (t = t
                              .replace(/eval code/g, "eval")
                              .replace(/(\(eval at [^()]*)|(,.*$)/g, ""));
                          var n = t
                              .replace(/^\s+/, "")
                              .replace(/\(eval code/g, "(")
                              .replace(/^.*?\s+/, ""),
                            r = n.match(/ (\(.+\)$)/);
                          n = r ? n.replace(r[0], "") : n;
                          var o = this.extractLocation(r ? r[1] : n),
                            a = (r && n) || void 0,
                            i =
                              ["eval", "<anonymous>"].indexOf(o[0]) > -1
                                ? void 0
                                : o[0];
                          return new e({
                            functionName: a,
                            fileName: i,
                            lineNumber: o[1],
                            columnNumber: o[2],
                            source: t,
                          });
                        }, this);
                    },
                    parseFFOrSafari: function (t) {
                      return t.stack
                        .split("\n")
                        .filter(function (e) {
                          return !e.match(r);
                        }, this)
                        .map(function (t) {
                          if (
                            (t.indexOf(" > eval") > -1 &&
                              (t = t.replace(
                                / line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g,
                                ":$1"
                              )),
                            -1 === t.indexOf("@") && -1 === t.indexOf(":"))
                          )
                            return new e({
                              functionName: t,
                            });
                          var n = /((.*".+"[^@]*)?[^@]*)(?:@)/,
                            r = t.match(n),
                            o = r && r[1] ? r[1] : void 0,
                            a = this.extractLocation(t.replace(n, ""));
                          return new e({
                            functionName: o,
                            fileName: a[0],
                            lineNumber: a[1],
                            columnNumber: a[2],
                            source: t,
                          });
                        }, this);
                    },
                    parseOpera: function (e) {
                      return !e.stacktrace ||
                        (e.message.indexOf("\n") > -1 &&
                          e.message.split("\n").length >
                            e.stacktrace.split("\n").length)
                        ? this.parseOpera9(e)
                        : e.stack
                        ? this.parseOpera11(e)
                        : this.parseOpera10(e);
                    },
                    parseOpera9: function (t) {
                      for (
                        var n = /Line (\d+).*script (?:in )?(\S+)/i,
                          r = t.message.split("\n"),
                          o = [],
                          a = 2,
                          i = r.length;
                        a < i;
                        a += 2
                      ) {
                        var s = n.exec(r[a]);
                        s &&
                          o.push(
                            new e({
                              fileName: s[2],
                              lineNumber: s[1],
                              source: r[a],
                            })
                          );
                      }
                      return o;
                    },
                    parseOpera10: function (t) {
                      for (
                        var n =
                            /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i,
                          r = t.stacktrace.split("\n"),
                          o = [],
                          a = 0,
                          i = r.length;
                        a < i;
                        a += 2
                      ) {
                        var s = n.exec(r[a]);
                        s &&
                          o.push(
                            new e({
                              functionName: s[3] || void 0,
                              fileName: s[2],
                              lineNumber: s[1],
                              source: r[a],
                            })
                          );
                      }
                      return o;
                    },
                    parseOpera11: function (n) {
                      return n.stack
                        .split("\n")
                        .filter(function (e) {
                          return !!e.match(t) && !e.match(/^Error created at/);
                        }, this)
                        .map(function (t) {
                          var n,
                            r = t.split("@"),
                            o = this.extractLocation(r.pop()),
                            a = r.shift() || "",
                            i =
                              a
                                .replace(/<anonymous function(: (\w+))?>/, "$2")
                                .replace(/\([^)]*\)/g, "") || void 0;
                          a.match(/\(([^)]*)\)/) &&
                            (n = a.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
                          var s =
                            void 0 === n || "[arguments not available]" === n
                              ? void 0
                              : n.split(",");
                          return new e({
                            functionName: i,
                            args: s,
                            fileName: o[0],
                            lineNumber: o[1],
                            columnNumber: o[2],
                            source: t,
                          });
                        }, this);
                    },
                  };
                })
                  ? r.apply(t, o)
                  : r) || (e.exports = a);
        })();
      },
      508: function (e, t) {
        var n, r, o;
        !(function (a, i) {
          "use strict";
          (r = []),
            void 0 ===
              (o =
                "function" ==
                typeof (n = function () {
                  function e(e) {
                    return !isNaN(parseFloat(e)) && isFinite(e);
                  }

                  function t(e) {
                    return e.charAt(0).toUpperCase() + e.substring(1);
                  }

                  function n(e) {
                    return function () {
                      return this[e];
                    };
                  }
                  var r = ["isConstructor", "isEval", "isNative", "isToplevel"],
                    o = ["columnNumber", "lineNumber"],
                    a = ["fileName", "functionName", "source"],
                    i = ["args"],
                    s = ["evalOrigin"],
                    c = r.concat(o, a, i, s);

                  function u(e) {
                    if (e)
                      for (var n = 0; n < c.length; n++)
                        void 0 !== e[c[n]] && this["set" + t(c[n])](e[c[n]]);
                  }
                  (u.prototype = {
                    getArgs: function () {
                      return this.args;
                    },
                    setArgs: function (e) {
                      if (
                        "[object Array]" !== Object.prototype.toString.call(e)
                      )
                        throw new TypeError("Args must be an Array");
                      this.args = e;
                    },
                    getEvalOrigin: function () {
                      return this.evalOrigin;
                    },
                    setEvalOrigin: function (e) {
                      if (e instanceof u) this.evalOrigin = e;
                      else {
                        if (!(e instanceof Object))
                          throw new TypeError(
                            "Eval Origin must be an Object or StackFrame"
                          );
                        this.evalOrigin = new u(e);
                      }
                    },
                    toString: function () {
                      var e = this.getFileName() || "",
                        t = this.getLineNumber() || "",
                        n = this.getColumnNumber() || "",
                        r = this.getFunctionName() || "";
                      return this.getIsEval()
                        ? e
                          ? "[eval] (" + e + ":" + t + ":" + n + ")"
                          : "[eval]:" + t + ":" + n
                        : r
                        ? r + " (" + e + ":" + t + ":" + n + ")"
                        : e + ":" + t + ":" + n;
                    },
                  }),
                    (u.fromString = function (e) {
                      var t = e.indexOf("("),
                        n = e.lastIndexOf(")"),
                        r = e.substring(0, t),
                        o = e.substring(t + 1, n).split(","),
                        a = e.substring(n + 1);
                      if (0 === a.indexOf("@"))
                        var i = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(a, ""),
                          s = i[1],
                          c = i[2],
                          l = i[3];
                      return new u({
                        functionName: r,
                        args: o || void 0,
                        fileName: s,
                        lineNumber: c || void 0,
                        columnNumber: l || void 0,
                      });
                    });
                  for (var l = 0; l < r.length; l++)
                    (u.prototype["get" + t(r[l])] = n(r[l])),
                      (u.prototype["set" + t(r[l])] = (function (e) {
                        return function (t) {
                          this[e] = Boolean(t);
                        };
                      })(r[l]));
                  for (var f = 0; f < o.length; f++)
                    (u.prototype["get" + t(o[f])] = n(o[f])),
                      (u.prototype["set" + t(o[f])] = (function (t) {
                        return function (n) {
                          if (!e(n))
                            throw new TypeError(t + " must be a Number");
                          this[t] = Number(n);
                        };
                      })(o[f]));
                  for (var d = 0; d < a.length; d++)
                    (u.prototype["get" + t(a[d])] = n(a[d])),
                      (u.prototype["set" + t(a[d])] = (function (e) {
                        return function (t) {
                          this[e] = String(t);
                        };
                      })(a[d]));
                  return u;
                })
                  ? n.apply(t, r)
                  : n) || (e.exports = o);
        })();
      },
      147: (e) => {
        "use strict";
        e.exports = {
          i8: "13.24.3",
        };
      },
    },
    t = {};

  function n(r) {
    var o = t[r];
    if (void 0 !== o) return o.exports;
    var a = (t[r] = {
      exports: {},
    });
    return e[r].call(a.exports, a, a.exports, n), a.exports;
  }
  (n.n = (e) => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return (
      n.d(t, {
        a: t,
      }),
      t
    );
  }),
    (n.d = (e, t) => {
      for (var r in t)
        n.o(t, r) &&
          !n.o(e, r) &&
          Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r],
          });
    }),
    (n.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
    (n.r = (e) => {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module",
        }),
        Object.defineProperty(e, "__esModule", {
          value: !0,
        });
    }),
    (() => {
      var e = n(422);
      if (e.BV && e.BV._private) {
        console &&
          console.warn &&
          console.warn("BV Loader should only be called once per page.");
      } else n(197).Z();
    })();
})();